import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Footer from "./Footer";
import Header from "./Header";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
const Pricing = () => {
  const [lgShow, setLgShow] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    interest: "",
    message: "",
  });

  const [thankYouPopup, setThankYouPopup] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaToken) {
      alert("Please verify the reCAPTCHA.");
      return;
    }

    await axios
      .post(
        "https://p506xqqura.execute-api.ap-south-1.amazonaws.com/contact",
        { ...formData, type: "contact" },
        { headers: { "Content-Type": "application/json" } },
      )
      .then(() => {
        setThankYouPopup(true);
        setFormData({ name: "", email: "", mobile: "", interest: "", message: "" });
        recaptchaRef.current.reset();
        setCaptchaToken(null);
        setLgShow(false);
        setShowThankYou(true);
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        alert("An error occurred while submitting the form. Please try again later.");
      });
  };

  const [activeTab, setActiveTab] = useState("step1");
  const [selectedOptions, setSelectedOptions] = useState([]);

  const steps = ["step1", "step2", "step3", "step4", "step5"];

  const goToNextStep = () => {
    const currentIndex = steps.indexOf(activeTab);
    if (currentIndex < steps.length - 1) {
      setActiveTab(steps[currentIndex + 1]);
    }
  };

  const goToPrevStep = () => {
    const currentIndex = steps.indexOf(activeTab);
    if (currentIndex > 0) {
      setActiveTab(steps[currentIndex - 1]);
    }
  };

  const handleCheckboxChange = (value) => {
    setSelectedOptions((prevSelected) =>
      prevSelected.includes(value)
        ? prevSelected.filter((item) => item !== value)
        : [...prevSelected, value]
    );
  };

  //   const handleCheckboxChange = (value) => {
  //     if (selectedOptions.includes(value)) {
  //       setSelectedOptions(selectedOptions.filter((item) => item !== value));
  //     } else {
  //       setSelectedOptions([...selectedOptions, value]);
  //     }
  //   };
  const [valueStepFour, setValueStepFour] = useState(0);
  const handleRangeChangeStepFour = (e) => {
    setValueStepFour(e.target.value);
  };

  const [valueStepFive, setValueStepFive] = useState(0);
  const handleRangeChangeStepFive = (e) => {
    setValueStepFive(e.target.value);
  };

  const [valueStepSix, setValueStepSix] = useState(0);
  const handleRangeChangeStepSix = (e) => {
    setValueStepSix(e.target.value);
  };

  return (
    <>
      <Header></Header>
      <div className="mainContent">
        <div className="bannerWrap innerBanner">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9">
                <div className="titleWrap">
                  <h2>Cost Calculator</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pricingPageWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="titleWrap">
                  <h2>
                    Follow the below steps and answer the questions to get your
                    quote!
                  </h2>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="pricingWrap">
                  <Tabs
                    defaultActiveKey="step1"
                    id="uncontrolled-tab-example"
                    className="mb-3"
                    activeKey={activeTab}
                    onSelect={(k) => setActiveTab(k)}
                  >
                    <Tab eventKey="step1" title="1">
                      <div className="pricingContent">
                        <h3>What type of application do you want to build</h3>
                        <p>(Select Atleast One Option)</p>
                        <ul>
                          <li>
                            <label class="controlCheckbox">
                              <input
                                type="checkbox"
                                checked={selectedOptions.includes("Option 1")}
                                onChange={() =>
                                  handleCheckboxChange("Option 1")
                                }
                              />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 299.679 299.679"
                                  >
                                    <g>
                                      <path
                                        d="M181.122 299.679c10.02 0 18.758-8.738 18.758-18.758v-43.808h12.525c7.516 0 12.525-5.011 12.525-12.525V99.466H74.749v125.123c0 7.515 5.01 12.525 12.525 12.525H99.8v43.808c0 10.02 8.736 18.758 18.758 18.758 10.019 0 18.756-8.738 18.756-18.758v-43.808h25.051v43.808c-.001 10.019 8.737 18.757 18.757 18.757zM256.214 224.589c10.02 0 18.756-8.737 18.756-18.758v-87.615c0-9.967-8.736-18.75-18.756-18.75-10.021 0-18.758 8.783-18.758 18.75v87.615c0 10.02 8.736 18.758 18.758 18.758zM43.466 224.589c10.021 0 18.758-8.737 18.758-18.758v-87.615c0-9.967-8.736-18.75-18.758-18.75-10.02 0-18.756 8.783-18.756 18.75v87.615c0 10.02 8.736 18.758 18.756 18.758zM209.899 1.89c-2.504-2.52-6.232-2.52-8.736 0l-16.799 16.743-.775.774c-9.961-4.988-21.129-7.479-33.566-7.503l-.182-.002h-.002l-.184.002c-12.436.024-23.604 2.515-33.564 7.503l-.777-.774L98.516 1.89c-2.506-2.52-6.232-2.52-8.736 0-2.506 2.506-2.506 6.225 0 8.729l16.25 16.253c-5.236 3.496-9.984 7.774-14.113 12.667-9.885 11.717-16.19 26.966-17.057 43.488-.008.172-.025.342-.033.514a72.074 72.074 0 0 0-.078 3.391H224.93c0-1.135-.027-2.266-.078-3.391-.008-.172-.025-.342-.035-.514-.865-16.522-7.172-31.772-17.057-43.487-4.127-4.893-8.877-9.171-14.113-12.667l16.252-16.253c2.506-2.505 2.506-6.224 0-8.73zm-91.365 63.173a9.383 9.383 0 1 1 0-18.766 9.383 9.383 0 0 1 0 18.766zm62.611 0a9.383 9.383 0 1 1 0-18.766 9.383 9.383 0 0 1 0 18.766z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Andriod</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 22.773 22.773"
                                  >
                                    <g>
                                      <path
                                        d="M15.769 0h.162c.13 1.606-.483 2.806-1.228 3.675-.731.863-1.732 1.7-3.351 1.573-.108-1.583.506-2.694 1.25-3.561C13.292.879 14.557.16 15.769 0zM20.67 16.716v.045c-.455 1.378-1.104 2.559-1.896 3.655-.723.995-1.609 2.334-3.191 2.334-1.367 0-2.275-.879-3.676-.903-1.482-.024-2.297.735-3.652.926h-.462c-.995-.144-1.798-.932-2.383-1.642-1.725-2.098-3.058-4.808-3.306-8.276v-1.019c.105-2.482 1.311-4.5 2.914-5.478.846-.52 2.009-.963 3.304-.765.555.086 1.122.276 1.619.464.471.181 1.06.502 1.618.485.378-.011.754-.208 1.135-.347 1.116-.403 2.21-.865 3.652-.648 1.733.262 2.963 1.032 3.723 2.22-1.466.933-2.625 2.339-2.427 4.74.176 2.181 1.444 3.457 3.028 4.209z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>IOS</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 32 32"
                                  >
                                    <g>
                                      <path
                                        d="M28 12c-.737 0-1.375.405-1.722 1h-.864l-1.707-1.707A1 1 0 0 0 23 11h-2.424a5.014 5.014 0 0 1-1.6 1.995c.008 0 .015.005.024.005h3.586l1.707 1.707A1 1 0 0 0 25 15h1.278c.347.595.985 1 1.722 1 1.103 0 2-.897 2-2s-.897-2-2-2zM28 7c-.757 0-1.41.428-1.75 1.05C26.17 8.03 26.09 8 26 8h-5.102a4.996 4.996 0 0 1 0 2H26c.089 0 .169-.029.25-.05.34.622.993 1.05 1.75 1.05 1.103 0 2-.897 2-2s-.897-2-2-2zM28 2c-.737 0-1.375.405-1.722 1H25a1 1 0 0 0-.707.293L22.586 5H19c-.006 0-.01.003-.016.003A5.018 5.018 0 0 1 20.572 7H23a1 1 0 0 0 .707-.293L25.414 5h.864c.347.595.985 1 1.722 1 1.103 0 2-.897 2-2s-.897-2-2-2zM16 5c-.137 0-.267.027-.4.04a5 5 0 0 0-9.2 0C6.267 5.027 6.137 5 6 5a4 4 0 1 0 0 8c.951 0 1.813-.346 2.5-.9.687.554 1.549.9 2.5.9s1.813-.346 2.5-.9c.687.554 1.549.9 2.5.9a4 4 0 0 0 0-8zM4 26c.737 0 1.375.405 1.722 1h.864l1.707-1.707A1 1 0 0 1 9 25h2.424c.35.799.91 1.479 1.6 1.995-.008 0-.015.005-.024.005H9.414l-1.707 1.707A1 1 0 0 1 7 29H5.722c-.347.595-.985 1-1.722 1-1.103 0-2-.897-2-2s.897-2 2-2zM4 21c.757 0 1.41.428 1.75 1.05.081-.021.161-.05.25-.05h5.102a4.996 4.996 0 0 0 0 2H6c-.089 0-.169-.029-.25-.05A1.994 1.994 0 0 1 4 25c-1.103 0-2-.897-2-2s.897-2 2-2zM4 16c.737 0 1.375.405 1.722 1H7a1 1 0 0 1 .707.293L9.414 19H13c.006 0 .01.003.016.003A5.018 5.018 0 0 0 11.428 21H9a1 1 0 0 1-.707-.293L6.586 19h-.864c-.347.595-.985 1-1.722 1-1.103 0-2-.897-2-2s.897-2 2-2zM16 19c.137 0 .267.027.4.04a5 5 0 0 1 9.2 0c.133-.013.263-.04.4-.04a4 4 0 1 1 0 8 3.962 3.962 0 0 1-2.5-.9c-.687.554-1.549.9-2.5.9s-1.813-.346-2.5-.9c-.687.554-1.549.9-2.5.9a4 4 0 0 1 0-8z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Hybrid</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 512 512"
                                  >
                                    <g>
                                      <path
                                        fill-rule="evenodd"
                                        d="m379.32 292.375-24.05-66.978c-1.61-4.438.704-9.318 5.132-10.918 4.428-1.59 9.308.714 10.918 5.152l16.051 44.634 16.05-44.634a8.508 8.508 0 0 1 8-5.655c3.623 0 6.843 2.259 8.051 5.655l16.05 44.634 16.05-44.634c1.56-4.438 6.44-6.742 10.918-5.152 4.428 1.6 6.742 6.48 5.132 10.918l-24.101 66.978a8.51 8.51 0 0 1-8 5.65c-3.622 0-6.843-2.259-8.05-5.65l-16.051-44.644-16.05 44.644a8.51 8.51 0 0 1-8 5.65c-3.622 0-6.842-2.259-8.05-5.65zM160.251 470.151c-9.208-13.027-17.51-27.96-24.805-44.352-18.415 5.303-35.673 11.869-51.472 19.602 29.887 27.19 66.264 47.401 106.466 58.068-10.667-8.88-20.78-20.02-30.189-33.318zm86.742 41.278c-26.315-3.256-51.321-20.77-72.805-51.145-8.1-11.456-15.497-24.533-22.038-38.893 29.635-7.089 61.685-11.089 94.843-11.698zm90.818-51.145c8.1-11.456 15.497-24.533 22.038-38.893-29.887-7.155-62.289-11.165-95.799-11.718v101.872c26.667-2.954 52.025-20.524 73.761-51.261zm90.214-14.883c-29.887 27.19-66.264 47.401-106.466 58.068 10.667-8.88 20.78-20.02 30.189-33.318 9.207-13.027 17.509-27.96 24.805-44.352 18.415 5.303 35.673 11.869 51.472 19.602zM403.27 334.226c-4.478 26.933-11.371 52.523-20.227 75.698 20.83 6.113 40.302 13.771 57.912 22.873 26.466-27.683 46.793-61.283 58.818-98.571zm-139.22 0h121.912c-4.428 25.449-11.019 49.515-19.471 71.24-31.95-7.879-66.616-12.287-102.44-12.861v-58.379zm-135.144 75.698c-20.78 6.113-40.252 13.781-57.862 22.873-26.465-27.683-46.792-61.283-58.818-98.571h96.503c4.478 26.933 11.371 52.524 20.177 75.698zm118.087-75.698H126.037c4.428 25.449 11.019 49.515 19.472 71.24 31.648-7.814 66.013-12.211 101.484-12.85zM145.509 106.533c-8.453 21.726-15.044 45.791-19.472 71.24h120.956v-58.39c-35.471-.638-69.836-5.031-101.484-12.85zm-16.603-4.462c-8.805 23.18-15.698 48.77-20.176 75.703H12.226c12.025-37.293 32.352-70.888 58.818-98.566 17.61 9.096 37.082 16.754 57.862 22.863zm6.54-15.86c7.296-16.403 15.598-31.336 24.805-44.362 9.409-13.298 19.522-24.433 30.189-33.318-40.201 10.667-76.579 30.878-106.466 58.068 15.799 7.733 33.057 14.304 51.472 19.612zm111.547 16.096c-33.158-.604-65.207-4.609-94.843-11.698 6.541-14.36 13.937-27.436 22.038-38.893 21.484-30.375 46.49-47.89 72.805-51.145zm112.856-11.698c-6.541-14.36-13.937-27.436-22.038-38.893C316.075 20.979 290.717 3.409 264.05.455v101.877c33.51-.558 65.912-4.569 95.799-11.723zm16.704-4.398c-7.296-16.403-15.598-31.336-24.805-44.362-9.409-13.298-19.522-24.433-30.189-33.318 40.201 10.667 76.579 30.878 106.466 58.068-15.799 7.733-33.057 14.304-51.472 19.612zm6.491 15.86c8.855 23.18 15.749 48.77 20.227 75.703h96.453c-11.975-37.293-32.302-70.888-58.767-98.566-17.611 9.096-37.083 16.754-57.913 22.863zM264.05 177.773v-58.38c35.824-.574 70.49-4.976 102.44-12.861 8.453 21.726 15.044 45.791 19.471 71.24H264.05zM512 255.997c0-21.076-2.566-41.555-7.397-61.157H7.396C2.566 214.443 0 234.921 0 255.997c0 21.082 2.566 41.56 7.396 61.162h497.207c4.831-19.602 7.397-40.08 7.397-61.162zm-199.799-30.601L288.1 292.375c-1.207 3.391-4.428 5.65-8.05 5.65a8.51 8.51 0 0 1-8-5.65L256 247.73l-16.05 44.644a8.51 8.51 0 0 1-8 5.65c-3.623 0-6.843-2.259-8.05-5.65l-24.101-66.978c-1.559-4.438.755-9.318 5.183-10.918 4.427-1.59 9.308.714 10.918 5.152l16.05 44.634 16-44.634c1.208-3.396 4.478-5.655 8.05-5.655 3.623 0 6.793 2.259 8.05 5.655l16 44.634 16.05-44.634c1.61-4.438 6.491-6.742 10.918-5.152 4.479 1.6 6.743 6.48 5.183 10.918zm-155.472 0-24.05 66.978c-1.208 3.391-4.428 5.65-8.051 5.65a8.51 8.51 0 0 1-8-5.65l-16.05-44.644-16.05 44.644c-1.207 3.391-4.428 5.65-8.05 5.65a8.51 8.51 0 0 1-8-5.65l-24.101-66.978c-1.61-4.438.704-9.318 5.132-10.918 4.428-1.59 9.359.714 10.918 5.152l16.05 44.634 16.05-44.634a8.524 8.524 0 0 1 8.05-5.655 8.506 8.506 0 0 1 8 5.655l16.05 44.634 16.051-44.634c1.61-4.438 6.49-6.742 10.918-5.152 4.429 1.6 6.743 6.48 5.133 10.918z"
                                        clip-rule="evenodd"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Web application</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                        </ul>
                        <div className="ctaWrap">
                          <button
                            type="button"
                            class="btn nextStep"
                            onClick={goToNextStep}
                          >
                            Continue to next step
                          </button>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="step2" title="2">
                      <div className="pricingContent stepTwoData">
                        <h3>What of these fits the category of your app?</h3>
                        <p>(Select Atleast One Option)</p>
                        <ul>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 32 32"
                                  >
                                    <g>
                                      <path
                                        d="m11 6 2-4h-1l-2 4zM9 6l2-4H3a1 1 0 0 0-1 1v3zM7 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM4 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM30 6V3a1 1 0 0 0-1-1H14l-2 4zM10.52 17.004 11.064 19h.702l.443-1.996zM15.209 17.004h-1.975L12.79 19h1.976zM15.417 16.067l.46-2.067H13.9l-.459 2.067zM18.417 16.067l.46-2.067H16.9l-.459 2.067zM22.442 16.067h1.975l.46-2.067h-1.976zM18.568 20l-.444 2h1.975l.444-2zM15.568 20l-.444 2h1.975l.444-2z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M2 7v22a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V7zm21.988 15.608A.5.5 0 0 1 23.5 23H14v1.092c.424.15.757.484.908.908h5.184a1.496 1.496 0 0 1 2.908.5 1.496 1.496 0 0 1-2.908.5h-5.184A1.496 1.496 0 0 1 12 25.5c0-.652.419-1.202 1-1.408V23h-1.5a.5.5 0 0 1-.482-.368L8.118 12H4.5a.5.5 0 1 1 0-1h4a.5.5 0 0 1 .482.368l.447 1.637A.57.57 0 0 1 9.5 13h16a.499.499 0 0 1 .488.608z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M14.543 20h-1.975l-.444 2h1.975zM21.568 20l-.444 2h1.975l.444-2zM21.417 16.067l.46-2.067H19.9l-.459 2.067zM12.417 16.067l.46-2.067H9.7l.564 2.067zM18.209 17.004h-1.975L15.79 19h1.976zM19.234 17.004 18.79 19h1.976l.443-1.996zM24.21 17.004h-1.976L21.79 19h1.976z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>E-commerce Platforms</h2>
                                  <span>Online retail, marketplaces.</span>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 64 64"
                                  >
                                    <g>
                                      <circle
                                        cx="32"
                                        cy="58"
                                        r="1"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></circle>
                                      <path
                                        d="M13 58a5.006 5.006 0 0 0 5 5h28a5.006 5.006 0 0 0 5-5v-5H13zm27-1h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2zm-8-2a3 3 0 1 1-3 3 3.003 3.003 0 0 1 3-3zm-12 2h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2zM53 13H11a1 1 0 0 0-1 1v6h44v-6a1 1 0 0 0-1-1zm-11 4.5a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm4 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm4 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1zM13 46h38v5H13zM51 6a5.006 5.006 0 0 0-5-5H18a5.006 5.006 0 0 0-5 5v5h38zM36 7h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2zm4 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1zM10 43a1 1 0 0 0 1 1h42a1 1 0 0 0 1-1V22H10zm28.793-15.293a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L43.086 32zM28.081 38.606l6-14a1 1 0 0 1 1.838.788l-6 14a1 1 0 0 1-1.838-.788zm-9.288-7.313 5-5a1 1 0 0 1 1.414 1.414L20.914 32l4.293 4.293a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Mobile Applications</h2>
                                  <span>Social networking, ride-sharing.</span>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 512 512"
                                  >
                                    <g>
                                      <path
                                        d="M1 376.08C1 406.363 25.637 431 55.92 431h400.16c30.283 0 54.92-24.637 54.92-54.92V351H1zM451 381c5.51 0 10 4.489 10 10 0 5.508-4.489 10-10 10-5.509 0-10-4.488-10-10 0-5.511 4.488-10 10-10zm-50 0h10c5.522 0 10 4.478 10 10s-4.478 10-10 10h-10c-5.522 0-10-4.478-10-10s4.478-10 10-10zm-50 0h10c5.522 0 10 4.478 10 10s-4.478 10-10 10h-10c-5.522 0-10-4.478-10-10s4.478-10 10-10zM456.08 1H55.92C25.637 1 1 25.637 1 55.92V331h510V55.92C511 25.637 486.363 1 456.08 1zM108.071 203.929c3.905 3.905 3.905 10.237 0 14.143-3.904 3.904-10.237 3.905-14.143 0l-40-40c-3.905-3.905-3.905-10.237 0-14.143l40-40c3.905-3.905 10.237-3.905 14.143 0 3.905 3.905 3.905 10.237 0 14.143L75.143 171zm62.631-70.504-20 80a10 10 0 0 1-12.127 7.276c-5.358-1.34-8.616-6.769-7.276-12.127l20-80c1.339-5.359 6.768-8.615 12.127-7.276 5.357 1.34 8.615 6.769 7.276 12.127zm23.227 84.646c-3.905-3.905-3.905-10.237 0-14.143L226.857 171l-32.929-32.929c-3.905-3.905-3.905-10.237 0-14.143 3.905-3.905 10.237-3.905 14.143 0l40 40c3.905 3.905 3.905 10.237 0 14.143l-40 40c-3.904 3.905-10.237 3.906-14.142 0zM451 301H251c-5.523 0-10-4.478-10-10s4.477-10 10-10h10v-30c0-5.523 4.478-10 10-10s10 4.477 10 10v30h20v-60c0-5.523 4.478-10 10-10s10 4.477 10 10v60h20v-40c0-5.523 4.478-10 10-10s10 4.477 10 10v40h20V181c0-5.523 4.478-10 10-10s10 4.477 10 10v100h20v-80c0-5.523 4.478-10 10-10s10 4.477 10 10v80h10c5.522 0 10 4.478 10 10s-4.478 10-10 10zM261 101c0-5.523 4.478-10 10-10h120c5.522 0 10 4.477 10 10s-4.478 10-10 10H271c-5.522 0-10-4.477-10-10zm190-30H271c-5.522 0-10-4.477-10-10s4.478-10 10-10h180c5.522 0 10 4.477 10 10s-4.478 10-10 10zM316 471h-10v-10c0-5.522-4.478-10-10-10h-80c-5.523 0-10 4.478-10 10v10h-10c-22.091 0-40 17.909-40 40h200c0-22.091-17.909-40-40-40z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Web Applications</h2>
                                  <span>
                                    Document editing, project management.
                                  </span>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 64 64"
                                  >
                                    <g>
                                      <path
                                        d="M9.2 34.8a4.79 4.79 0 0 1 9.57 0 4.72 4.72 0 0 1-.44 2h8.31v-9.17a.5.5 0 0 1 .27-.45.51.51 0 0 1 .53 0 3.77 3.77 0 1 0 2.22-6.83 3.71 3.71 0 0 0-2.21.73.49.49 0 0 1-.53.05.51.51 0 0 1-.28-.45V10.63H2.16a1.71 1.71 0 0 0-1.71 1.7v24.48h9.2a4.58 4.58 0 0 1-.45-2.01zm-4-20.49h9.05a.51.51 0 1 1 0 1h-9a.51.51 0 1 1 0-1zm0 3.86h15.6a.51.51 0 0 1 0 1H5.19a.51.51 0 0 1 0-1zm0 3.86h12.32a.51.51 0 1 1 0 1H5.19a.51.51 0 1 1 0-1zm-.51 4.36a.5.5 0 0 1 .51-.5h15.6a.5.5 0 0 1 .51.5.51.51 0 0 1-.51.51H5.19a.51.51 0 0 1-.51-.51zM61.84 0H37.37v9.19a4.63 4.63 0 0 1 2-.45 4.79 4.79 0 1 1-2 9.14v8.3h9.19a.51.51 0 0 1 .46.28.53.53 0 0 1-.02.54 3.65 3.65 0 0 0-.74 2.21 3.78 3.78 0 1 0 6.8-2.21.51.51 0 0 1 0-.53.48.48 0 0 1 .45-.28h10.04V1.7A1.71 1.71 0 0 0 61.84 0zM46.58 5.61h6.85a.51.51 0 1 1 0 1h-6.85a.51.51 0 1 1 0-1zM58.86 18.2H46.58a.53.53 0 0 1-.51-.51.51.51 0 0 1 .51-.51h12.28a.5.5 0 0 1 .51.51.51.51 0 0 1-.51.51zm-12.79-4.37a.51.51 0 0 1 .51-.51H56.7a.51.51 0 0 1 .51.51.52.52 0 0 1-.51.51H46.58a.52.52 0 0 1-.51-.51zm12.79-3.35H46.58a.51.51 0 1 1 0-1h12.28a.51.51 0 0 1 0 1z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M19.85 50.47a4.78 4.78 0 0 1 4.77-4.78 4.65 4.65 0 0 1 2 .44v-8.3h-9.2a.49.49 0 0 1-.45-.29A.51.51 0 0 1 17 37a3.62 3.62 0 0 0 .73-2.21 3.77 3.77 0 0 0-7.54 0A3.62 3.62 0 0 0 11 37a.52.52 0 0 1-.42.82H.45V62.3A1.7 1.7 0 0 0 2.16 64h24.48v-9.18a5 5 0 0 1-2 .43 4.78 4.78 0 0 1-4.79-4.78ZM4.23 45.53h6.85a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.51H4.23a.5.5 0 0 1-.5-.51.5.5 0 0 1 .5-.5Zm13.39 12.59H4.23a.51.51 0 0 1 0-1h13.39a.51.51 0 1 1 0 1ZM3.73 53.75a.5.5 0 0 1 .5-.51h10.12a.51.51 0 1 1 0 1H4.23a.5.5 0 0 1-.5-.49Zm13.89-3.35H4.23a.51.51 0 0 1 0-1h13.39a.51.51 0 1 1 0 1Z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M45.08 39.83a4.79 4.79 0 0 1-9.57 0 4.89 4.89 0 0 1 .43-2h-8.29V47a.52.52 0 0 1-.28.46.5.5 0 0 1-.53 0 3.64 3.64 0 0 0-2.22-.72 3.77 3.77 0 0 0 0 7.53 3.65 3.65 0 0 0 2.22-.73.5.5 0 0 1 .53 0 .51.51 0 0 1 .28.45V64h24.47a1.7 1.7 0 0 0 1.7-1.7V37.83h-9.18a4.94 4.94 0 0 1 .44 2Zm-11.59 7.62h9a.51.51 0 0 1 0 1h-9a.51.51 0 1 1 0-1ZM49.09 60h-15.6a.5.5 0 0 1-.51-.5.51.51 0 0 1 .51-.51h15.6a.51.51 0 0 1 .51.51.5.5 0 0 1-.51.5ZM33 55.68a.51.51 0 0 1 .51-.51h12.31a.51.51 0 0 1 0 1H33.49a.51.51 0 0 1-.49-.49Zm16.6-3.86a.51.51 0 0 1-.51.51h-15.6a.51.51 0 1 1 0-1h15.6a.51.51 0 0 1 .51.49Z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Enterprise Solutions</h2>
                                  <span>CRM, ERP systems.</span>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 512 512"
                                  >
                                    <g data-name="Layer 16">
                                      <circle
                                        cx="256"
                                        cy="256"
                                        r="70.71"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></circle>
                                      <path
                                        d="M442.78 282.43a48.59 48.59 0 0 0-15.7 11.66l-73.25-24.9a98.1 98.1 0 0 1-12.25 36l73.28 24.91a48.63 48.63 0 1 0 27.92-47.64zM69.22 131.78c.75-.35 1.49-.72 2.21-1.1l97.4 79a99.34 99.34 0 0 1 24-29.48l-97.47-79.04a48.61 48.61 0 1 0-26.14 30.62zM322.23 394.23l-17.52-52.4a97.91 97.91 0 0 1-36 12.07l17.5 52.37c-1 .74-1.92 1.5-2.85 2.3a58.93 58.93 0 1 0 38.9-14.34zM337.91 201l90.67-90.67a58 58 0 1 0-26.87-26.87L311 174.09A99.57 99.57 0 0 1 337.91 201zM174.18 311.17l-99.77 100.1a53 53 0 1 0 26.91 26.83L201.1 338a99.6 99.6 0 0 1-26.92-26.83z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Social Media Platforms</h2>
                                  <span>Networking, content sharing.</span>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 512 512"
                                  >
                                    <g>
                                      <path
                                        fill-rule="evenodd"
                                        d="m326.014 0-5.395 14.057a10.964 10.964 0 0 1-1.188 2.525H192.569a10.964 10.964 0 0 1-1.188-2.525L185.986 0zM131.836 0a14.735 14.735 0 0 0-14.7 14.7v440.279h277.73V14.7A14.7 14.7 0 0 0 380.164 0h-40.637L332.4 18.611c-1.039 2.574-4.059 10.543-12.473 10.543H192.074c-8.365 0-11.434-7.969-12.423-10.543L172.523 0zm-14.7 497.3v-29.749h277.73V497.3a14.7 14.7 0 0 1-14.7 14.7h-248.33a14.735 14.735 0 0 1-14.7-14.7zm132.554-7.523a6.311 6.311 0 1 0 6.336-6.286h-.05a6.3 6.3 0 0 0-6.286 6.286zm6.336-151.066A111.221 111.221 0 1 1 367.2 227.489 111.347 111.347 0 0 1 256.025 338.71zm0-209.869a98.624 98.624 0 1 1-98.648 98.648 98.746 98.746 0 0 1 98.648-98.648zM204.35 248.971a8.64 8.64 0 0 1-8.662-8.662V214.67a8.682 8.682 0 0 1 8.662-8.712h30.144v-30.144a8.7 8.7 0 0 1 8.662-8.662h25.689a8.7 8.7 0 0 1 8.661 8.662v30.144h30.144a8.682 8.682 0 0 1 8.662 8.712v25.639a8.64 8.64 0 0 1-8.662 8.662h-30.144v30.193a8.7 8.7 0 0 1-8.661 8.663h-25.689a8.7 8.7 0 0 1-8.662-8.663v-30.193zm3.91-30.391h30.193a8.7 8.7 0 0 0 8.662-8.662v-30.193h17.819v30.193a8.671 8.671 0 0 0 8.662 8.662h30.144v17.82H273.6a8.64 8.64 0 0 0-8.662 8.662v30.144h-17.823v-30.145a8.671 8.671 0 0 0-8.662-8.662H208.26z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Health and Fitness Apps</h2>
                                  <span>Diet tracking, workout guides.</span>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 96 96"
                                  >
                                    <g>
                                      <path
                                        d="M23.295 12.572a1.95 1.95 0 1 0 2.76-2.76l-5.24-5.24a1.952 1.952 0 0 0-2.76 2.76zM71.328 13.143c.498 0 .996-.191 1.377-.572l5.24-5.24a1.952 1.952 0 0 0-2.76-2.76l-5.24 5.24a1.952 1.952 0 0 0 1.383 3.332zM9.592 30.412c-.218.041-.335.18-.335.419v58.213l.602-.103c11.952-1.734 23.815-.811 35.261 2.741l.928.285v-23.49c-4.309-.905-7.554-4.733-7.554-9.307v-3.538c-1.954-1.692-3.22-4.16-3.223-6.942 0-1.358-.612-2.67-1.726-3.697-4.14-3.809-6.514-9.13-6.778-14.722-5.854-.832-11.951-.777-17.175.141zm25.31 42.355c1.078 0 1.954.874 1.954 1.952s-.876 1.952-1.954 1.952h-16.37c-1.078 0-1.949-.874-1.949-1.952s.871-1.952 1.949-1.952zm-1.674-11.144a1.952 1.952 0 0 1-1.952 1.952H18.534a1.952 1.952 0 0 1 0-3.904h12.742c1.078 0 1.952.874 1.952 1.952zm-5.572-13.994a1.954 1.954 0 0 1-1.954 1.952h-7.164c-1.078 0-1.954-.874-1.954-1.952s.876-1.952 1.954-1.952h7.164c1.077 0 1.954.874 1.954 1.952zM53.569 59.17v-1.512a9.209 9.209 0 0 1-2.071.254h-7.001a9.079 9.079 0 0 1-2.099-.264v1.521a5.614 5.614 0 0 0 5.607 5.61c3.068.001 5.564-2.514 5.564-5.609zM30.56 29.154a17.465 17.465 0 0 0 5.626 12.968c1.927 1.775 2.989 4.108 2.989 6.568a5.329 5.329 0 0 0 5.322 5.319h1.549V42.008a1.952 1.952 0 0 1 3.904 0v12.001h1.549a5.326 5.326 0 0 0 5.322-5.319c0-2.461 1.062-4.796 2.994-6.571a17.474 17.474 0 0 0 5.621-12.818c0-4.744-1.873-9.184-5.273-12.494a17.305 17.305 0 0 0-12.641-4.938c-9.278.248-16.886 8.003-16.962 17.285zm16.681-11.155c3.446.049 6.742 1.671 8.593 4.606a1.953 1.953 0 0 1-3.305 2.079c-1.116-1.772-3.043-2.866-5.183-2.782-1.078.049-1.976-.819-2.003-1.897a1.953 1.953 0 0 1 1.898-2.006zM86.027 88.941l.716.103V30.831c0-.24-.117-.378-.362-.425-5.591-.914-11.364-.933-17.143-.131-.261 5.588-2.651 10.913-6.783 14.716-1.116 1.029-1.731 2.341-1.731 3.699 0 2.796-1.279 5.275-3.25 6.968v3.512a9.518 9.518 0 0 1-7.521 9.307V92c11.66-3.711 24.083-4.834 36.074-3.059zm-15.728-42.36h7.17a1.952 1.952 0 0 1 0 3.904h-7.17c-1.078 0-1.949-.874-1.949-1.952s.871-1.952 1.949-1.952zm-5.575 13.09h12.745c1.078 0 1.949.874 1.949 1.952s-.871 1.952-1.949 1.952H64.724a1.952 1.952 0 0 1 0-3.904zm-3.631 16.983c-1.078 0-1.954-.874-1.954-1.952s.876-1.952 1.954-1.952h14.775c1.078 0 1.954.874 1.954 1.952s-.876 1.952-1.954 1.952z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Educational and Learning Platforms</h2>
                                  <span>E-learning, language learning.</span>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 64 64"
                                  >
                                    <g>
                                      <path
                                        d="M7 30c0-6.065 4.935-11 11-11 2.417 0 4.648.793 6.465 2.12l7.504-7.504L37 18.227V11H3v38h34v-8H18c-6.065 0-11-4.935-11-11zm0 17H5v-2h2zm4 0H9v-2h2zm4 0h-2v-2h2zM37 6c0-1.654-1.346-3-3-3h-9v3c0 1.13-.391 2.162-1.026 3H37zm-3 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M24.305 39H31V23.414l-2.716 2.716c.455 1.206.716 2.507.716 3.87 0 3.72-1.861 7.008-4.695 9z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M18 21c-4.963 0-9 4.038-9 9s4.037 9 9 9 9-4.038 9-9-4.037-9-9-9zm3 7h-2v-.146a.855.855 0 0 0-.854-.854h-.291a.856.856 0 0 0-.855.854c0 .326.181.619.473.764l1.949.975A2.838 2.838 0 0 1 21 32.146a2.849 2.849 0 0 1-2 2.709V37h-2v-2.145a2.849 2.849 0 0 1-2-2.709V32h2v.146c0 .471.384.854.854.854h.291a.856.856 0 0 0 .855-.854.848.848 0 0 0-.473-.764l-1.949-.975A2.838 2.838 0 0 1 15 27.854c0-1.274.845-2.343 2-2.709V23h2v2.145c1.155.366 2 1.435 2 2.709zM3 58c0 1.654 1.346 3 3 3h28c1.654 0 3-1.346 3-3v-7H3zm27-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zm-14 0a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1zM6 55a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zM15 6V3H6C4.346 3 3 4.346 3 6v3h13.026A4.948 4.948 0 0 1 15 6zM20 9c1.654 0 3-1.346 3-3V3h-6v3c0 1.654 1.346 3 3 3zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM49 39h2V25.949l-2 2.148zM53 39h2V21.652l-2 2.149zM54.028 12.614l1.854 1.854-11.82 12.945L37.065 21H37v-.06l-4.97-4.556-6.059 6.058c.519.547.98 1.148 1.379 1.793l4.619-4.62 11.975 10.977L51 23.014V23h.013l6.461-6.94 1.911 1.912 1.34-6.697z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M33 23.273V39h2V25.107zM45 39h2v-8.755l-2 2.148zM41 39h2v-6.56l-2-1.833zM37 39h2V28.773l-2-1.833z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Financial and Fintech Applications</h2>
                                  <span>Payment processing, investing.</span>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 511.762 511.762"
                                  >
                                    <g>
                                      <path
                                        d="M74.267 320.864V190.898c-1.827-49.216-72.457-49.179-74.267 0v129.967c1.828 49.215 72.457 49.178 74.267-.001zM474.867 153.765h-83.55c-52.256 2.813-47.58 77.296 4.642 74.267v92.833c1.824 49.205 72.451 49.19 74.267 0v-92.833h4.642c49.219-1.843 49.166-72.451-.001-74.267zM223.867 367.281c61.484 0 111.4-49.916 111.4-111.4-5.519-147.6-217.303-147.56-222.8.001 0 61.483 49.916 111.399 111.4 111.399zm0-148.533c20.495 0 37.133 16.636 37.133 37.133-1.837 49.2-72.437 49.187-74.267 0 0-20.497 16.639-37.133 37.134-37.133z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M75.453 107.468c78.204-81.485 218.626-81.481 296.828 0 5.858 5.858 15.355 5.857 21.213 0 5.858-5.858 5.857-15.355 0-21.213-89.372-93.122-249.885-93.118-339.254 0-5.858 5.858-5.858 15.355 0 21.213 5.857 5.857 15.354 5.857 21.213 0z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M334.341 119.331c-62.113-51.793-158.838-51.791-220.949 0-6.437 5.215-7.428 14.66-2.214 21.098 5.215 6.437 14.66 7.429 21.098 2.214 51.492-42.936 131.691-42.936 183.182.001 6.437 5.213 15.883 4.222 21.098-2.215 5.214-6.438 4.222-15.883-2.215-21.098zM372.281 404.294c-78.204 81.485-218.626 81.481-296.828 0-5.858-5.857-15.356-5.857-21.213 0-5.858 5.858-5.857 15.355 0 21.213 89.372 93.122 249.885 93.118 339.254 0 5.858-5.858 5.858-15.355 0-21.213-5.858-5.857-15.355-5.858-21.213 0z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M111.178 371.333c-5.214 6.438-4.223 15.883 2.214 21.098 62.113 51.793 158.838 51.791 220.949 0 6.437-5.215 7.428-14.66 2.214-21.098-5.214-6.437-14.661-7.428-21.098-2.214-51.489 42.936-131.693 42.936-183.182 0-6.437-5.215-15.881-4.222-21.097 2.214z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>IoT Applications</h2>
                                  <span>Home automation, smart lighting.</span>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 512 512"
                                  >
                                    <g>
                                      <path
                                        d="M512 363.78c-1.2-66.8-9.09-134.35-22.03-202.53-10.54-47.37-48.46-89.56-109.05-92.65-44.73-1.84-53.38 23.64-104.06 23.15-13.88-.09-27.75-.09-41.63 0-50.69.49-59.36-24.99-104.07-23.15-60.6 3.09-99.7 45.17-109.09 92.65C9.12 229.43 1.23 296.97.04 363.77c-.29 46.51 45.63 77.45 75.93 79.57 58.53 4.42 105.03-98.79 140.46-98.8 26.41.15 52.81.16 79.22 0 35.44 0 81.9 103.23 140.47 98.81 30.29-2.12 77.4-33.27 75.89-79.57zM190.94 233.44h-27.3v27.3c0 11.52-9.34 20.86-20.86 20.86s-20.86-9.34-20.86-20.86v-27.3h-27.3c-11.52 0-20.86-9.34-20.86-20.86s9.34-20.86 20.86-20.86h27.3v-27.3c0-11.52 9.34-20.86 20.86-20.86s20.86 9.34 20.86 20.86v27.3h27.3c11.52 0 20.86 9.34 20.86 20.86s-9.34 20.86-20.86 20.86zm168.57 48.15c-16.33.44-29.91-12.46-30.35-28.78-.43-16.38 12.48-29.98 28.8-30.4 16.34-.41 29.94 12.48 30.36 28.82.41 16.34-12.48 29.94-28.81 30.36zm49.25-78.85c-16.33.46-29.94-12.45-30.39-28.78-.41-16.36 12.48-29.94 28.82-30.39 16.36-.43 29.94 12.48 30.38 28.82.43 16.33-12.49 29.94-28.81 30.35z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Gaming</h2>
                                  <span>Action games, puzzle games.</span>
                                </div>
                              </div>
                            </label>
                          </li>
                        </ul>
                        <div className="ctaWrap">
                          <button
                            type="button"
                            class="btn prevStep"
                            onClick={goToPrevStep}
                          >
                            Back
                          </button>
                          <button
                            type="button"
                            class="btn nextStep"
                            onClick={goToNextStep}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="step3" title="3">
                      <div className="pricingContent stepThreeData">
                        <h3>List some of the features</h3>
                        <p>(Select Atleast One Option)</p>
                        <ul>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 296.999 296.999"
                                  >
                                    <g>
                                      <path
                                        d="M141.914 185.802a9.952 9.952 0 0 0 6.587 2.486 9.95 9.95 0 0 0 6.587-2.486c2.385-2.101 58.391-52.021 58.391-103.793 0-35.842-29.148-65.002-64.977-65.002-35.83 0-64.979 29.16-64.979 65.002-.002 51.772 56.006 101.692 58.391 103.793zm6.587-120.777c9.302 0 16.845 7.602 16.845 16.984 0 9.381-7.543 16.984-16.845 16.984-9.305 0-16.847-7.604-16.847-16.984 0-9.382 7.542-16.984 16.847-16.984z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="m273.357 185.773-7.527-26.377a9.966 9.966 0 0 0-9.583-7.232h-53.719a225.332 225.332 0 0 1-6.158 8.699c-15.057 20.23-30.364 33.914-32.061 35.41a23.904 23.904 0 0 1-15.808 5.967 23.91 23.91 0 0 1-15.81-5.969c-1.695-1.494-17.004-15.18-32.06-35.408a226.109 226.109 0 0 1-6.158-8.699h-53.72a9.966 9.966 0 0 0-9.583 7.232l-8.971 31.436 200.529 36.73 50.629-41.789zM296.617 267.291l-19.23-67.396-95.412 80.098h105.06a9.964 9.964 0 0 0 9.582-12.702zM48.793 209.888l-30.44-5.576-17.97 62.979a9.968 9.968 0 0 0 9.583 12.701h38.827v-70.104zM62.746 212.445v67.547h97.527l48.584-40.785z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Maps and Geolocation</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 512 512"
                                  >
                                    <g>
                                      <path
                                        d="M377 242c-74.441 0-135 60.559-135 135s60.559 135 135 135 135-60.559 135-135-60.559-135-135-135zm60 150h-60c-8.29 0-15-6.71-15-15v-60c0-8.29 6.71-15 15-15s15 6.71 15 15v45h45c8.29 0 15 6.71 15 15s-6.71 15-15 15zM481 46c0-8.402-6.598-15-15-15h-75v45c0 8.398-6.598 15-15 15s-15-6.602-15-15V31h-60v45c0 8.398-6.598 15-15 15s-15-6.602-15-15V31h-60v45c0 8.398-6.598 15-15 15s-15-6.602-15-15V31h-60v45c0 8.398-6.598 15-15 15s-15-6.602-15-15V31H15C6.598 31 0 37.598 0 46v75h481zm0 0"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M226 301h3.602c5.476-10.64 11.656-20.855 19.218-30H226c-8.29 0-15-6.71-15-15s6.71-15 15-15h30c6.145 0 11.39 3.707 13.71 8.992C298.45 225.715 335.52 211 376 211h-30c-8.29 0-15-6.71-15-15s6.71-15 15-15h30c8.29 0 15 6.71 15 15s-6.71 15-15 15c39.855 0 76.453 14.21 105 37.82V151H0v285c0 8.29 6.71 15 15 15h214.215C217.656 428.469 211 403.016 211 376c0-16.512 2.96-32.246 7.496-47.297C214.094 326.09 211 321.496 211 316c0-8.29 6.71-15 15-15zm0-120h30c8.29 0 15 6.71 15 15s-6.71 15-15 15h-30c-8.29 0-15-6.71-15-15s6.71-15 15-15zm-90 210h-30c-8.29 0-15-6.71-15-15s6.71-15 15-15h30c8.29 0 15 6.71 15 15s-6.71 15-15 15zm0-60h-30c-8.29 0-15-6.71-15-15s6.71-15 15-15h30c8.29 0 15 6.71 15 15s-6.71 15-15 15zm0-60h-30c-8.29 0-15-6.71-15-15s6.71-15 15-15h30c8.29 0 15 6.71 15 15s-6.71 15-15 15zm0-60h-30c-8.29 0-15-6.71-15-15s6.71-15 15-15h30c8.29 0 15 6.71 15 15s-6.71 15-15 15zM121 15c0-8.402-6.598-15-15-15S91 6.598 91 15v16h30zM211 15c0-8.402-6.598-15-15-15s-15 6.598-15 15v16h30zM301 15c0-8.402-6.598-15-15-15s-15 6.598-15 15v16h30zM391 15c0-8.402-6.598-15-15-15s-15 6.598-15 15v16h30zm0 0"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Calendars and Scheduling</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 496 496"
                                  >
                                    <g>
                                      <path
                                        d="M344 59.496H48c-26.47 0-48 21.53-48 48v172c0 26.47 21.53 48 48 48h43.08l.92 43.34c.281 13.002 15.209 20.285 25.63 12.44 78.785-59.398 67.621-50.982 73.99-55.78H344c26.47 0 48-21.53 48-48v-172c0-26.47-21.53-48-48-48zm-93 191H141c-8.84 0-16-7.16-16-16s7.16-16 16-16h110c8.84 0 16 7.16 16 16s-7.16 16-16 16zm29-70H112c-8.84 0-16-7.16-16-16s7.16-16 16-16h168c8.84 0 16 7.16 16 16s-7.16 16-16 16zm216 27v132c0 26.51-21.49 48-48 48h-43.15l-.85 33.41c-.227 8.69-7.363 15.59-16 15.59-6.322 0-1.703 1.809-82.86-49H235c-12.236 0-23.414-4.602-31.897-12.165-10.987-9.796-4.097-27.974 10.623-27.974h145.57c31.041 0 56.204-25.163 56.204-56.204V175.496c0-8.837 7.163-16 16-16H448c26.51 0 48 21.49 48 48z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Messaging and Chat</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 64 64"
                                  >
                                    <g>
                                      <path
                                        d="M53 21H24v2h21.97a1.01 1.01 0 0 1 1.03.977A3.999 3.999 0 0 0 51.023 28 1.01 1.01 0 0 1 52 29.03v5.94a1.01 1.01 0 0 1-.977 1.03A3.999 3.999 0 0 0 47 40.023a1.01 1.01 0 0 1-1.03.977H24v2h29a1 1 0 0 0 1-1V22a1 1 0 0 0-1-1Z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M24 46a1 1 0 0 1-2 0V18a1 1 0 0 1 2 0v1h20v-4H10v34h34v-4H24ZM10 54a5.006 5.006 0 0 0 5 5h24a5.006 5.006 0 0 0 5-5v-3H10Zm17-1a2 2 0 1 1-2 2 2 2 0 0 1 2-2ZM44 10a5.006 5.006 0 0 0-5-5H15a5.006 5.006 0 0 0-5 5v3h34Zm-14 0h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2Z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M50 34.08v-4.16A6.038 6.038 0 0 1 45.08 25H24v14h21.08A6.038 6.038 0 0 1 50 34.08ZM33 30a1 1 0 0 1-2 0v-.15a.85.85 0 0 0-.85-.85h-.3a.85.85 0 0 0-.85.85.859.859 0 0 0 .47.77l1.95.97a2.856 2.856 0 0 1-.42 5.28V37a1 1 0 0 1-2 0v-.13a2.845 2.845 0 0 1-2-2.72V34a1 1 0 0 1 2 0v.15a.85.85 0 0 0 .85.85h.3a.85.85 0 0 0 .85-.85.859.859 0 0 0-.47-.77l-1.95-.97a2.856 2.856 0 0 1 .42-5.28V27a1 1 0 0 1 2 0v.13a2.845 2.845 0 0 1 2 2.72Z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Payment Systems</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 512 512"
                                  >
                                    <g>
                                      <path
                                        fill-rule="evenodd"
                                        d="M309.261 431.557H29.579v48.165a15.863 15.863 0 0 0 15.8 15.8h248.085a15.863 15.863 0 0 0 15.8-15.8v-48.165zM149.969 52.81a6.734 6.734 0 0 1 0-13.467h38.9a6.734 6.734 0 0 1 0 13.467zm38.589 408.359a4.059 4.059 0 0 1 0 8.118h-38.277a4.059 4.059 0 0 1 0-8.118zM150.281 447.7h38.277a17.526 17.526 0 0 1 0 35.052h-38.277a17.526 17.526 0 0 1 0-35.052zM426.024 93.494a144.75 144.75 0 0 0-204.1 201.616 6.728 6.728 0 0 1 1.237 7.03 288.512 288.512 0 0 1-17.977 37.226 155.44 155.44 0 0 1-10.644 15.968 163.478 163.478 0 0 0 36.434-.711 145.051 145.051 0 0 0 43.76-13.158 6.716 6.716 0 0 1 5.915-.295A144.739 144.739 0 0 0 426.024 93.494zM309.261 363.769a157.318 157.318 0 0 1-31.112-9.06 158.3 158.3 0 0 1-45.387 13.223 182.858 182.858 0 0 1-52.575-.788 6.73 6.73 0 0 1-3.457-11.7q8.54-8.662 16.88-22.867a266.789 266.789 0 0 0 15.662-32.042 158.179 158.179 0 0 1 99.989-248V32.278a15.863 15.863 0 0 0-15.8-15.8H45.376a15.863 15.863 0 0 0-15.8 15.8V418.09h279.685zM410.055 257.4a8.02 8.02 0 0 1 0 16.04H265.261a8.02 8.02 0 0 1 0-16.04zm-129.7-13.468c10.087-12.377 10.744-17.038 10.744-47.609 0-15.339 5.4-29.168 14.13-39.125 8.516-9.714 20.231-15.722 33.126-15.722s24.609 6.008 33.125 15.722c8.73 9.957 14.13 23.786 14.13 39.125 0 14.916.026 2.149.018 6.332-.03 14.813-.045 22.044 1.943 28.351 1.483 4.7 3.762 8.187 7.576 12.926zm68.179-114.967a54.678 54.678 0 0 0-21.7.272 10.889 10.889 0 0 1 21.7-.272zM322.608 286.9h30.1a15.308 15.308 0 0 1-30.1 0zm43.688 0a28.773 28.773 0 0 1-57.275 0h-43.76a21.489 21.489 0 0 1-2.6-42.817c.8-.942 1.618-1.91 2.4-2.833 11.885-14 12.57-14.808 12.57-44.934 0-18.671 6.686-35.633 17.5-47.963a61.32 61.32 0 0 1 18.534-14.464 23.983 23.983 0 0 1-.324-3.9 24.356 24.356 0 1 1 48.484 3.306 61.06 61.06 0 0 1 19.759 15.06c10.81 12.33 17.5 29.292 17.5 47.963 0 10.393-.018-1.781-.035 6.332-.027 13.369-.04 19.9 1.365 24.353 1.223 3.88 4.093 7.293 9.7 13.959l2.636 3.133a21.489 21.489 0 0 1-2.685 42.807z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Push Notifications</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 512 512"
                                  >
                                    <g>
                                      <path
                                        fill-rule="evenodd"
                                        d="M28.8 41.11h454.4a28.837 28.837 0 0 1 28.8 28.8v69.652H0V69.91a28.837 28.837 0 0 1 28.8-28.8zm454.4 429.78H28.8A28.827 28.827 0 0 1 0 442.09V156.632h512V442.09a28.827 28.827 0 0 1-28.8 28.8zM58.965 117.153a26.817 26.817 0 1 0-26.817-26.817 26.85 26.85 0 0 0 26.817 26.817zm0-36.564a9.748 9.748 0 1 0 9.747 9.747 9.76 9.76 0 0 0-9.747-9.747zm74.935 36.564a26.817 26.817 0 1 0-26.817-26.817 26.849 26.849 0 0 0 26.817 26.817zm0-36.564a9.748 9.748 0 1 0 9.748 9.747 9.76 9.76 0 0 0-9.748-9.747zm74.931 36.564a26.817 26.817 0 1 0-26.817-26.817 26.843 26.843 0 0 0 26.817 26.817zm0-36.564a9.748 9.748 0 1 0 9.748 9.747 9.755 9.755 0 0 0-9.748-9.747zm83.34 9.747a8.528 8.528 0 0 0 8.53 8.535h170.616a8.533 8.533 0 1 0 0-17.065H300.7a8.525 8.525 0 0 0-8.53 8.53zm38.291 184.3a40.791 40.791 0 1 0-39.126-29.44l-78.761 42.232a40.742 40.742 0 1 0 0 52.658l78.761 42.231a40.83 40.83 0 1 0 8.087-15.032l-78.761-42.226a40.9 40.9 0 0 0 1.6-11.3 40.39 40.39 0 0 0-1.6-11.3l78.761-42.237a40.636 40.636 0 0 0 31.039 14.408zm0 95.317a23.665 23.665 0 1 0 23.672 23.672 23.7 23.7 0 0 0-23.672-23.672zm-148.925-32.525a23.67 23.67 0 1 0-23.672-23.667 23.7 23.7 0 0 0 23.672 23.667zm148.926-127.2a23.67 23.67 0 1 0 23.672 23.672 23.7 23.7 0 0 0-23.672-23.669z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Social Media Integration</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 32 32"
                                    fill-rule="evenodd"
                                  >
                                    <g>
                                      <path
                                        d="M13.056 28.468A1.978 1.978 0 0 1 13 28V15a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v11.531l-5.761-4.786a2.001 2.001 0 0 0-2.508-.039zM18 15.583a2.418 2.418 0 0 0 0 4.834 2.418 2.418 0 0 0 0-4.834zm11.767 13.354A2 2 0 0 1 28 30H15c-.19 0-.376-.027-.555-.079l8.516-6.638zM11.298 13.486c-.195.476-.298.99-.298 1.514v4H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v7h-4c-.129 0-.257.006-.385.019a1.2 1.2 0 0 0-.404-1.509L9.145 6.04a1.2 1.2 0 0 0-1.878.989v6.942a1.2 1.2 0 0 0 1.878.989z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                        class="hovered-path"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Image and Video Processing</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 512 512"
                                  >
                                    <g>
                                      <path
                                        fill-rule="evenodd"
                                        d="M339.208 67.335a6.986 6.986 0 0 1 9.818-1.2 211.077 211.077 0 0 1 31.48 30.371c2.492 2.96 2.102 7.365-.848 9.857a7.036 7.036 0 0 1-4.512 1.639 6.971 6.971 0 0 1-5.355-2.487 197.778 197.778 0 0 0-29.383-28.361c-3.051-2.381-3.591-6.782-1.2-9.818zm54.484 189.389a6.99 6.99 0 0 0 9.816-1.176l12.327-15.689c-1.069 28.777-8.304 55.977-20.42 80.32h15.515c11.176-24.434 17.831-51.369 18.892-79.734l11.867 15.104a6.99 6.99 0 0 0 10.992-8.64l-24.499-31.181c-2.743-3.634-8.228-3.74-11.08-.112l-24.587 31.293a6.99 6.99 0 0 0 1.176 9.816zM170.348 40.946c.549 0 1.109-.072 1.663-.202a197.018 197.018 0 0 1 38.049-5.379 7.008 7.008 0 0 0 6.7-7.298 6.994 6.994 0 0 0-7.303-6.695 212.718 212.718 0 0 0-40.749 5.764c-3.76.916-6.068 4.7-5.148 8.459.766 3.2 3.639 5.35 6.787 5.35zm238.9 140.417a7.006 7.006 0 0 0 8.58 4.95c3.731-.998 5.953-4.839 4.95-8.57a212.97 212.97 0 0 0-15.651-40.956c-1.74-3.451-5.958-4.835-9.399-3.094a7.013 7.013 0 0 0-3.09 9.413 198.232 198.232 0 0 1 14.609 38.257zM266.498 41.004a198.622 198.622 0 0 1 35.813 12.749 6.996 6.996 0 0 0 9.298-3.369c1.639-3.499.14-7.669-3.36-9.308a212.36 212.36 0 0 0-38.353-13.65c-3.736-.93-7.548 1.34-8.488 5.09s1.34 7.548 5.09 8.488zm-25.64 387.413a199.227 199.227 0 0 1-22.12 1.229c-16.783 0-33.055-2.087-48.57-6.013a195.822 195.822 0 0 1-45.403-17.739 6.975 6.975 0 0 0-6.672 12.25 210.023 210.023 0 0 0 48.684 19.052 211.573 211.573 0 0 0 51.961 6.451 212.51 212.51 0 0 0 36.783-3.194 65.382 65.382 0 0 1-14.663-12.035zM85.606 345.033a6.985 6.985 0 0 0-7.78-6.107 6.993 6.993 0 0 0-6.117 7.78l2.376 19.8c-33.957-36.579-52.587-83.96-52.587-134.093 0-70.156 37.76-135.607 98.536-170.808 3.354-1.928 4.492-6.218 2.555-9.558a7.003 7.003 0 0 0-9.573-2.555c-31.499 18.244-57.918 44.474-76.407 75.853-19.044 32.318-29.113 69.351-29.113 107.067 0 53.671 19.94 104.392 56.279 143.57l-19.049-2.29c-3.837-.448-7.331 2.28-7.789 6.112a7.001 7.001 0 0 0 6.121 7.789l39.51 4.743a7.004 7.004 0 0 0 5.789-2.001 7.026 7.026 0 0 0 2-5.784l-4.753-39.519zm418.895 39.894c0 27.911-22.836 50.748-50.747 50.748H347.755l-45.151 54.961v-54.961h-13.867c-27.911 0-50.747-22.836-50.747-50.747s22.836-50.748 50.747-50.748h165.016c27.911 0 50.747 22.836 50.747 50.747zm-187.985 0 5.836-3.369a6.97 6.97 0 0 0-6.946-12.086l-5.83 3.366v-6.735a7 7 0 1 0-14 0v6.735l-5.83-3.366a6.97 6.97 0 0 0-6.946 12.086l5.836 3.369-5.836 3.369a6.97 6.97 0 0 0 6.946 12.086l5.83-3.366v6.735a7 7 0 1 0 14 0v-6.735l5.83 3.366a6.97 6.97 0 0 0 6.946-12.086zm68.669 0 5.836-3.369a6.97 6.97 0 0 0-6.946-12.086l-5.83 3.366v-6.735a7 7 0 1 0-14 0v6.735l-5.83-3.366a6.97 6.97 0 0 0-6.946 12.086l5.836 3.369-5.836 3.369a6.97 6.97 0 0 0 6.946 12.086l5.83-3.366v6.735a7 7 0 1 0 14 0v-6.735l5.83 3.366a6.97 6.97 0 0 0 6.946-12.086zm68.669 0 5.836-3.369a6.97 6.97 0 0 0-6.946-12.086l-5.83 3.366v-6.735a7 7 0 1 0-14 0v6.735l-5.83-3.366a6.97 6.97 0 0 0-6.946 12.086l5.836 3.369-5.836 3.369a6.97 6.97 0 0 0 6.946 12.086l5.83-3.366v6.735a7 7 0 1 0 14 0v-6.735l5.83 3.366a6.97 6.97 0 0 0 6.946-12.086zM112.07 337.375V204.51c0-10.807 8.842-19.649 19.65-19.649h15.157v-35.56c0-39.523 32.337-71.86 71.859-71.86s71.86 32.337 71.86 71.86v35.56h15.158c10.807 0 19.649 8.842 19.649 19.649v115.669h-36.665c-25.66 0-47.934 15.092-58.396 36.845H131.72c-10.807 0-19.65-8.842-19.65-19.649zm130.058-88.304c0-12.919-10.473-23.392-23.392-23.392s-23.391 10.473-23.391 23.392c0 8.997 5.08 16.805 12.527 20.719v35.552c0 5.975 4.889 10.864 10.864 10.864 5.976 0 10.864-4.889 10.864-10.864V269.79c7.447-3.914 12.527-11.722 12.527-20.719zm-63.643-64.21h80.503v-35.56c0-22.077-18.176-40.252-40.252-40.252s-40.251 18.175-40.251 40.252z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Authentication and Security</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 64 64"
                                  >
                                    <g data-name="Layer 16">
                                      <path
                                        d="M27 51h10v4H27zM41 57H23a2 2 0 0 0-2 2v2h22v-2a2 2 0 0 0-2-2Z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <circle
                                        cx="32"
                                        cy="14"
                                        r="4"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></circle>
                                      <path
                                        d="M24.269 16.022a7.925 7.925 0 0 0 .834 2.015 1 1 0 0 1-.1 1.151l-1.545 1.826 1.527 1.528L26.811 21a1 1 0 0 1 1.152-.1 7.9 7.9 0 0 0 2.015.834 1 1 0 0 1 .743.885L30.92 25h2.16l.2-2.384a1 1 0 0 1 .743-.885 7.9 7.9 0 0 0 2.015-.834 1 1 0 0 1 1.152.1l1.826 1.545 1.527-1.528L39 19.188a1 1 0 0 1-.1-1.151 7.925 7.925 0 0 0 .834-2.015 1 1 0 0 1 .885-.744L43 15.08v-2.16l-2.384-.2a1 1 0 0 1-.885-.743 7.9 7.9 0 0 0-.831-2.014 1 1 0 0 1 .1-1.152l1.545-1.826-1.53-1.527L37.189 7a1 1 0 0 1-1.152.1 7.9 7.9 0 0 0-2.015-.834 1 1 0 0 1-.743-.885L33.08 3h-2.16l-.2 2.384a1 1 0 0 1-.743.885 7.9 7.9 0 0 0-2.015.834A1 1 0 0 1 26.811 7l-1.826-1.542-1.527 1.527L25 8.811a1 1 0 0 1 .1 1.152 7.9 7.9 0 0 0-.834 2.015 1 1 0 0 1-.885.743L21 12.92v2.16l2.384.2a1 1 0 0 1 .885.742ZM32 8a6 6 0 1 1-6 6 6.006 6.006 0 0 1 6-6ZM3 46a3 3 0 0 0 3 3h52a3 3 0 0 0 3-3v-3H3Zm24-1h10v2H27Z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M58 11H44.042h.041A1 1 0 0 1 45 12v4a1 1 0 0 1-.917 1l-2.623.218a9.824 9.824 0 0 1-.5 1.2l1.7 2.009a1 1 0 0 1-.057 1.353l-2.828 2.828a1 1 0 0 1-1.353.057l-2.008-1.7a9.773 9.773 0 0 1-1.2.5L35 26.083A1 1 0 0 1 34 27h-4a1 1 0 0 1-1-.917l-.218-2.623a9.773 9.773 0 0 1-1.2-.5l-2.008 1.7a1 1 0 0 1-1.353-.057l-2.828-2.828a1 1 0 0 1-.057-1.353l1.7-2.009a9.824 9.824 0 0 1-.5-1.2L19.917 17A1 1 0 0 1 19 16v-4a1 1 0 0 1 .917-1h.041H6a3 3 0 0 0-3 3v27h58V14a3 3 0 0 0-3-3ZM30 39h-2v-3h-3v3h-2v-6.5a3.5 3.5 0 0 1 7 0Zm5-4h-2v4h-2v-9a1 1 0 0 1 1-1h3a3 3 0 0 1 0 6Zm6 4h-2V29h2Z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M26.5 31a1.5 1.5 0 0 0-1.5 1.5V34h3v-1.5a1.5 1.5 0 0 0-1.5-1.5ZM35 31h-2v2h2a1 1 0 0 0 0-2Z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>API Integration</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 512 512"
                                  >
                                    <g>
                                      <path
                                        fill-rule="evenodd"
                                        d="M43.382 281.094h50.744c2.754 0 5 2.246 5 5v53.463l-60.743 47.01V286.093a5.008 5.008 0 0 1 4.999-4.999zM20.877 440.515l132.254-102.353 169.138 35.733a7.97 7.97 0 0 0 6.843-1.775l154.313-120.876-3.152 14.334a7.993 7.993 0 0 0 15.625 3.375l7.894-36.001c1.052-4.886-2.619-9.573-7.666-9.652l-36.851-.65a7.97 7.97 0 0 0-.25 15.938l14.384.254-151.493 118.666-169.119-35.724a7.955 7.955 0 0 0-6.499 1.496L11.127 427.89a7.976 7.976 0 0 0 9.75 12.625zm350.219-397.11a7.998 7.998 0 1 1-1.375-15.937l36.716-3.22c5.219-.45 9.449 4.231 8.571 9.33l-4.041 36.143a7.986 7.986 0 0 1-15.875-1.75l1.598-14.297-23.883 24.086a7.977 7.977 0 0 1-11.312-11.25l24.177-24.383zM43.289 227.853a7.972 7.972 0 0 1-9.813-12.563l9.217-7.221a7.972 7.972 0 0 1 9.813 12.563zm32.22-25.243a7.972 7.972 0 0 1-9.813-12.563l9.217-7.221a7.972 7.972 0 0 1 9.813 12.563zm32.221-25.243a7.972 7.972 0 0 1-9.813-12.563l9.217-7.221a7.972 7.972 0 0 1 9.813 12.563zm32.221-25.244a7.972 7.972 0 0 1-9.813-12.563l9.217-7.221a7.972 7.972 0 0 1 9.813 12.563zm32.22-25.243a7.972 7.972 0 0 1-9.813-12.563l9.217-7.221a7.972 7.972 0 0 1 9.813 12.563zm41.593-15.409a7.985 7.985 0 1 1-4.937 15.187l-11.137-3.614a7.985 7.985 0 1 1 4.937-15.187zm38.934 12.632a7.985 7.985 0 0 1-4.937 15.187l-11.137-3.613a7.985 7.985 0 1 1 4.937-15.187zm38.933 12.632a7.985 7.985 0 0 1-4.937 15.187l-11.137-3.613a7.985 7.985 0 0 1 4.937-15.187zm20.469-20.409a7.976 7.976 0 0 1 11.281-.031 7.976 7.976 0 0 1 .031 11.281l-8.244 8.314c-3.106 3.124-8.157 3.138-11.281.031s-3.138-8.158-.031-11.281zm28.82-29.066c3.106-3.124 8.157-3.138 11.281-.031s3.138 8.158.031 11.281l-8.244 8.314a7.976 7.976 0 0 1-11.281.031 7.976 7.976 0 0 1-.031-11.281zM99.126 400.188v82.594c0 2.754-2.246 5-5 5H43.382a5.01 5.01 0 0 1-5-5v-35.584zm282.627-253.981h50.744c2.754 0 5 2.246 5 5v95.443l-60.743 47.581V151.206a5.008 5.008 0 0 1 4.999-4.999zm55.743 161.337v175.238c0 2.754-2.246 5-5 5h-50.744a5.01 5.01 0 0 1-5-5V355.125zM268.964 191.203h50.744a5.01 5.01 0 0 1 5 4.999v138.797l-6.784 5.314-53.96-11.4V196.202a5.01 5.01 0 0 1 5-4.999zm55.743 198.847v92.734a5.01 5.01 0 0 1-5 4.999h-50.744a5.01 5.01 0 0 1-5-4.999V377.928l54.999 11.619c1.91.404 3.838.568 5.745.503zM156.173 235.887h50.743c2.754 0 5 2.246 5 5v77.03l-60.743-12.833v-64.197c0-2.754 2.246-5 5-5zm55.743 131.045v115.85c0 2.754-2.246 5-5 5h-50.743a5.01 5.01 0 0 1-5-5V359.908l5.895-4.562z"
                                        clip-rule="evenodd"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Analytics and Reporting</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 512 512"
                                  >
                                    <g>
                                      <path
                                        d="m386.909 94.709-2.69 34.123a15.004 15.004 0 0 0 6.14 13.321c4.23 3.077 9.762 3.702 14.56 1.72l31.62-13.111 31.62 13.111a15.004 15.004 0 0 0 20.7-15.041l-2.69-34.123 22.23-26.033a15.014 15.014 0 0 0 2.87-14.381 15.022 15.022 0 0 0-10.77-9.951l-33.29-7.991-17.88-29.193c-2.72-4.45-7.57-7.16-12.79-7.16s-10.06 2.71-12.79 7.161l-17.88 29.193-33.29 7.991a15.006 15.006 0 0 0-10.76 9.951 14.985 14.985 0 0 0 2.86 14.381zM206.37 94.709l-2.69 34.123a15.004 15.004 0 0 0 20.7 15.041l31.62-13.11 31.62 13.111c4.798 1.983 10.337 1.356 14.56-1.72a15.004 15.004 0 0 0 6.14-13.321l-2.69-34.123 22.23-26.033a14.985 14.985 0 0 0 2.86-14.381 15.008 15.008 0 0 0-10.76-9.951l-33.29-7.991-17.88-29.193a15 15 0 0 0-25.58 0l-17.88 29.193-33.29 7.991a15.006 15.006 0 0 0-10.76 9.951 14.985 14.985 0 0 0 2.86 14.381zM25.828 94.709l-2.69 34.123a15.004 15.004 0 0 0 20.7 15.041l31.62-13.111 31.62 13.111c4.798 1.983 10.337 1.356 14.56-1.72a15.004 15.004 0 0 0 6.14-13.321l-2.69-34.123 22.23-26.033a14.985 14.985 0 0 0 2.86-14.381 15.008 15.008 0 0 0-10.76-9.951l-33.29-7.991-17.88-29.192a15 15 0 0 0-25.58 0l-17.88 29.193-33.29 7.991a15.006 15.006 0 0 0-10.76 9.951 14.985 14.985 0 0 0 2.86 14.381zM468.329 176.017H43.67C19.59 176.017 0 195.609 0 219.691v176.677c0 24.082 19.59 43.674 43.67 43.674h143.45l57.51 66.796c5.65 6.882 17.089 6.881 22.739 0l57.51-66.796h143.45c24.08 0 43.67-19.592 43.67-43.674V219.691c0-24.082-19.59-43.674-43.67-43.674zM292 347.323c-8.28 0-15-6.721-15-15.001 0-8.291 6.72-15.001 15-15.001h115c8.28 0 15 6.711 15 15.001 0 8.281-6.72 15.001-15 15.001zm115-60.005H105c-8.28 0-15-6.721-15-15.001 0-8.281 6.72-15.001 15-15.001h302c8.28 0 15 6.721 15 15.001s-6.72 15.001-15 15.001zm-172 45.004c0 8.281-6.72 15.001-15 15.001H105c-8.28 0-15-6.721-15-15.001 0-8.291 6.72-15.001 15-15.001h115c8.28 0 15 6.71 15 15.001z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Feedback and Ratings</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 64 64"
                                  >
                                    <g>
                                      <path
                                        d="M1 15v41c0 3.86 3.14 7 7 7h48c3.859 0 7-3.14 7-7V15zm17 31h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zm0-10h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zm0-10h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zm34 28h-6a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2zm-11-8a11.939 11.939 0 0 1-7.74-2.845l-8.553 8.552a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l8.552-8.552A11.942 11.942 0 0 1 29 34c0-6.617 5.383-12 12-12s12 5.383 12 12-5.383 12-12 12zm10-12c0 5.514-4.486 10-10 10s-10-4.486-10-10 4.486-10 10-10 10 4.486 10 10zm5-33H8C4.14 1 1 4.14 1 8v5h62V8c0-3.86-3.141-7-7-7zM44 9c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm6 0c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm6 0c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Search Functionality</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 512 512"
                                  >
                                    <g>
                                      <path
                                        d="M30 112.5h153.8c-6.8-19.4-6.9-40.5-.3-60H30c-16.6 0-30 13.4-30 30s13.4 30 30 30zM482 112.5c16.6 0 30-13.4 30-30s-13.4-30-30-30H358.6c6.6 19.5 6.4 40.6-.3 60zM30 286.5h18.8c-6.8-19.4-6.9-40.5-.3-60H30c-16.6 0-30 13.4-30 30s13.4 30 30 30zM482 226.5H223.6c6.5 19.5 6.4 40.6-.3 60H482c16.6 0 30-13.4 30-30s-13.4-30-30-30zM183.4 400.5H30c-16.6 0-30 13.4-30 30s13.4 30 30 30h153.8c-6.8-19.4-6.9-40.5-.4-60zM482 400.5H358.6c6.6 19.5 6.4 40.6-.3 60H482c16.6 0 30-13.4 30-30s-13.4-30-30-30z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <circle
                                        cx="271"
                                        cy="82"
                                        r="76"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></circle>
                                      <circle
                                        cx="136"
                                        cy="256"
                                        r="76"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></circle>
                                      <circle
                                        cx="271"
                                        cy="430"
                                        r="76"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></circle>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Customizable User Profiles</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 512 512"
                                  >
                                    <g fill-rule="evenodd">
                                      <path
                                        d="M306.968 353.345v-21.214l-7.317-3.69a4.585 4.585 0 0 1-2.521-4.095h-.011v-30.388a4.6 4.6 0 0 1 2.509-4.1l7.34-4.2v-21.37H205.032v21.37l7.532 4.309a4.589 4.589 0 0 1 2.313 3.986v30.388a4.6 4.6 0 0 1-2.835 4.247l-7.014 3.538v21.214zM256 279.482c14.108 0 21.122 17.122 11.194 27.037l8.543 25.584a4.592 4.592 0 0 1-4.346 6.039v.014h-30.782a4.589 4.589 0 0 1-4.228-6.407l8.425-25.229c-9.928-9.913-2.916-27.038 11.194-27.038z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M486.8 146.67H25.2v274.864a15.308 15.308 0 0 0 15.251 15.251h431.09a15.308 15.308 0 0 0 15.259-15.251zM129.945 389.24c-7.946 7.948-21.461 2.21-21.461-8.885v-14.223c0-11.1 13.514-16.833 21.461-8.885a12.54 12.54 0 0 1 3.691 8.885v14.223a12.54 12.54 0 0 1-3.691 8.885zm-38.281-2.46c0 6.053-9.2 6.053-9.2 0v-27.073c0-6.053 9.2-6.053 9.2 0zm-29.7 2.46c-7.947 7.948-21.462 2.209-21.462-8.885v-14.223c0-11.092 13.513-16.834 21.462-8.885a12.542 12.542 0 0 1 3.691 8.885v14.223a12.54 12.54 0 0 1-3.691 8.885zm63.7-54.574c0 6.053-9.195 6.053-9.195 0v-27.073c0-6.053 9.195-6.053 9.195 0zm-29.7 2.46c-7.964 7.948-21.474 2.209-21.474-8.885v-14.223c0-11.094 13.514-16.833 21.462-8.885a12.542 12.542 0 0 1 3.691 8.885v14.223a12.542 12.542 0 0 1-3.691 8.885zm-38.281-2.46c0 6.053-9.195 6.053-9.195 0v-27.073c0-6.053 9.2-6.053 9.2 0v27.073zm72.262-48.766c-7.946 7.948-21.461 2.21-21.461-8.885V262.79c0-11.1 13.514-16.833 21.461-8.886a12.54 12.54 0 0 1 3.691 8.886v14.222a12.54 12.54 0 0 1-3.691 8.885zm-38.281-2.46c0 6.053-9.2 6.053-9.2 0v-27.076c0-6.053 9.2-6.053 9.2 0v27.073zm-29.7 2.46c-7.947 7.948-21.462 2.21-21.462-8.885V262.79c0-11.093 13.513-16.835 21.462-8.886a12.542 12.542 0 0 1 3.691 8.886v14.222a12.54 12.54 0 0 1-3.691 8.885zm63.7-54.574c0 6.053-9.195 6.053-9.195 0V204.25c0-6.053 9.195-6.053 9.195 0v27.073zm-29.7 2.46C88 241.731 74.49 235.992 74.49 224.9v-14.224c0-11.094 13.514-16.834 21.462-8.886a12.542 12.542 0 0 1 3.691 8.886V224.9a12.54 12.54 0 0 1-3.691 8.885zm-38.281-2.46c0 6.053-9.195 6.053-9.195 0V204.25c0-6.053 9.2-6.053 9.2 0v27.073zm118.68 139.891c-9.863 9.863-26.785 2.835-26.785-11.094a15.708 15.708 0 0 1 23.014-13.88l7.164-7.213a4.587 4.587 0 0 1 3.5-1.613h12.584v-8.1h.011a4.586 4.586 0 0 1 2.521-4.094l7.317-3.69v-8.112h-25.415a15.707 15.707 0 0 1-26.1 6.5c-9.862-9.862-2.836-26.785 11.094-26.785a15.7 15.7 0 0 1 15.006 11.093h25.412v-7.6l-7.34-4.2a4.6 4.6 0 0 1-2.509-4.1v-5.092h-12.584a4.587 4.587 0 0 1-3.5-1.613l-7.164-7.213a15.708 15.708 0 0 1-23.014-13.88c0-13.928 16.921-20.957 26.785-11.094a15.692 15.692 0 0 1 2.734 18.513l6.051 6.091h10.689V259.7a4.6 4.6 0 0 1 4.6-4.6h17.2v-20.7a38.37 38.37 0 0 1 76.739 0v20.7h17.195a4.6 4.6 0 0 1 4.6 4.6v14.342h10.689l6.051-6.092a15.708 15.708 0 0 1 13.829-23.108c13.929 0 20.957 16.922 11.094 26.785a15.691 15.691 0 0 1-18.418 2.784l-7.164 7.214a4.589 4.589 0 0 1-3.5 1.613h-12.586v5.092a4.594 4.594 0 0 1-2.313 3.987l-7.532 4.308v7.6h25.412a15.707 15.707 0 0 1 26.1-6.5c9.862 9.862 2.836 26.786-11.094 26.786a15.7 15.7 0 0 1-15.006-11.093h-25.416v8.112l7.014 3.537a4.6 4.6 0 0 1 2.835 4.247v8.1h12.584a4.589 4.589 0 0 1 3.5 1.613l7.164 7.213a15.708 15.708 0 0 1 23.014 13.88c0 13.931-16.924 20.955-26.785 11.094a15.69 15.69 0 0 1-2.734-18.512l-6.051-6.093h-10.692v11.331a4.6 4.6 0 0 1-4.6 4.6H200.435a4.6 4.6 0 0 1-4.6-4.6v-11.328h-10.687L179.1 352.7a15.692 15.692 0 0 1-2.734 18.513zm277.966-11.51c0-6.053 9.195-6.053 9.195 0v27.073c0 6.053-9.195 6.053-9.195 0zm-29.4-6.151a12.6 12.6 0 0 1 12.577 12.576v14.222c0 11.094-13.514 16.834-21.462 8.886a12.542 12.542 0 0 1-3.691-8.886v-14.222a12.6 12.6 0 0 1 12.576-12.576zm-38.59 6.151c0-6.053 9.195-6.053 9.195 0v27.073c0 6.053-9.195 6.053-9.195 0zm72.584-58.265a12.6 12.6 0 0 1 12.577 12.576v14.222c0 11.095-13.514 16.834-21.462 8.886a12.541 12.541 0 0 1-3.69-8.886v-14.222a12.6 12.6 0 0 1 12.576-12.576zm-38.591 6.151c0-6.053 9.195-6.053 9.195 0v27.073c0 6.053-9.195 6.053-9.195 0zm-29.4-6.151a12.6 12.6 0 0 1 12.577 12.576v14.222c0 11.1-13.515 16.833-21.462 8.886a12.54 12.54 0 0 1-3.691-8.886v-14.222a12.6 12.6 0 0 1 12.576-12.576zm-4.6-45.078c0-6.053 9.195-6.053 9.195 0v27.073c0 6.053-9.195 6.053-9.195 0zm38.59-6.151a12.6 12.6 0 0 1 12.577 12.576v14.223c0 11.094-13.514 16.833-21.462 8.885a12.542 12.542 0 0 1-3.691-8.885v-14.223a12.6 12.6 0 0 1 12.576-12.576zm29.4 6.151c0-6.053 9.195-6.053 9.195 0v27.073c0 6.053-9.195 6.053-9.195 0zm4.6-58.265a12.6 12.6 0 0 1 12.578 12.576V224.9c0 11.094-13.514 16.833-21.462 8.885a12.541 12.541 0 0 1-3.69-8.885v-14.225a12.6 12.6 0 0 1 12.579-12.575zm-38.591 6.151c0-6.053 9.195-6.053 9.195 0v27.073c0 6.053-9.195 6.053-9.195 0zm-29.4-6.151a12.6 12.6 0 0 1 12.577 12.576V224.9c0 11.1-13.515 16.833-21.462 8.885a12.54 12.54 0 0 1-3.691-8.885v-14.225A12.6 12.6 0 0 1 390.94 198.1z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M87.066 228.279a3.4 3.4 0 0 0 3.382-3.381v-14.222c0-4.444-6.763-4.444-6.763 0V224.9a3.4 3.4 0 0 0 3.381 3.379zM121.06 280.393a3.4 3.4 0 0 0 3.381-3.381V262.79c0-4.444-6.762-4.444-6.762 0v14.222a3.4 3.4 0 0 0 3.381 3.381zM53.073 280.393a3.4 3.4 0 0 0 3.381-3.381V262.79c0-4.444-6.762-4.444-6.762 0v14.222a3.4 3.4 0 0 0 3.381 3.381zM87.066 331.622a3.4 3.4 0 0 0 3.382-3.381v-14.223c0-4.443-6.763-4.443-6.763 0v14.223a3.4 3.4 0 0 0 3.381 3.381zM121.06 383.736a3.4 3.4 0 0 0 3.381-3.381v-14.223c0-4.443-6.762-4.443-6.762 0v14.223a3.4 3.4 0 0 0 3.381 3.381zM53.073 383.736a3.4 3.4 0 0 0 3.381-3.381v-14.223c0-4.443-6.762-4.443-6.762 0v14.223a3.4 3.4 0 0 0 3.381 3.381zM427.318 363.748a3.381 3.381 0 0 0-5.766 2.384v14.222c0 4.444 6.763 4.444 6.763 0v-14.222a3.366 3.366 0 0 0-.997-2.384zM461.311 311.634a3.38 3.38 0 0 0-5.765 2.384v14.222c0 4.444 6.762 4.444 6.762 0v-14.222a3.366 3.366 0 0 0-.997-2.384zM393.325 311.634a3.381 3.381 0 0 0-5.766 2.384v14.222c0 4.444 6.762 4.444 6.762 0v-14.222a3.366 3.366 0 0 0-.996-2.384zM165.268 366.618a6.5 6.5 0 1 0-6.5-6.5 6.5 6.5 0 0 0 6.5 6.5zM169.862 304.225a6.5 6.5 0 1 0 0 9.187 6.5 6.5 0 0 0 0-9.187zM169.862 255.934a6.5 6.5 0 1 0 0 9.187 6.5 6.5 0 0 0 0-9.187zM342.138 364.716a6.5 6.5 0 1 0 0-9.187 6.5 6.5 0 0 0 0 9.187zM346.732 302.323a6.5 6.5 0 1 0 6.495 6.5 6.5 6.5 0 0 0-6.495-6.5zM346.732 254.032a6.5 6.5 0 1 0 6.495 6.495 6.5 6.5 0 0 0-6.495-6.495zM260.7 290.624c-5.444-5.444-14.235 1.325-10.5 7.961a6.709 6.709 0 0 0 2.356 2.438 4.588 4.588 0 0 1 1.957 5.369l-7.536 22.568h18.048l-7.48-22.4a4.587 4.587 0 0 1 1.9-5.537 6.662 6.662 0 0 0 1.255-10.399zM285.175 255.1v-20.7a29.175 29.175 0 0 0-58.349 0v20.7zM343.2 110.914c-6.053 0-6.053-9.2 0-9.2h9.579c6.053 0 6.053 9.2 0 9.2zm45.221 0c-6.053 0-6.053-9.2 0-9.2H398c6.053 0 6.053 9.2 0 9.2zm48.306 0c-6.053 0-6.053-9.2 0-9.2h9.579c6.053 0 6.053 9.2 0 9.2zm-379.9 0c-6.053 0-6.053-9.2 0-9.2h259.589c6.053 0 6.053 9.2 0 9.2zM25.2 137.475h461.6V90.466a15.308 15.308 0 0 0-15.251-15.251H40.455A15.307 15.307 0 0 0 25.2 90.466zM427.318 260.4a3.381 3.381 0 0 0-5.766 2.384v14.223c0 4.443 6.763 4.443 6.763 0v-14.218a3.368 3.368 0 0 0-.997-2.389zM461.311 208.291a3.38 3.38 0 0 0-5.765 2.384V224.9c0 4.443 6.762 4.443 6.762 0v-14.225a3.368 3.368 0 0 0-.997-2.384zM393.325 208.291a3.381 3.381 0 0 0-5.766 2.384V224.9c0 4.443 6.762 4.443 6.762 0v-14.225a3.367 3.367 0 0 0-.996-2.384z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Data Encryption</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 28 28"
                                  >
                                    <g>
                                      <path
                                        fill="#0a0b12"
                                        d="m25.7 24.3-22-22c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l7.5 7.5-6.3 4c-.3.1-.5.5-.5.8v3c0 .3.1.6.4.8s.5.2.8.2l6.8-1.7v3.2l-3.6 2.7c-.3.3-.5.7-.3 1.1.1.4.5.7.9.7h12c.4 0 .8-.3.9-.7s0-.9-.3-1.1L17 21.5v-3.1l7.3 7.3c.4.4 1 .4 1.4 0s.4-1 0-1.4z"
                                        opacity="1"
                                        data-original="#0a0b12"
                                      ></path>
                                      <path
                                        fill="#858589"
                                        d="M12 7.3c.6 0 1-.4 1-1v-.9l1-1 1 1V11c0 .3.2.7.5.8l7.5 4.7v1.8c0 .6.4 1 1 1s1-.4 1-1V16c0-.3-.2-.7-.5-.8L17 10.4V5c0-.3-.1-.5-.3-.7l-2-2c-.4-.4-1-.4-1.4 0l-2 2c-.2.2-.3.4-.3.7v1.3c0 .6.4 1 1 1z"
                                        opacity="1"
                                        data-original="#858589"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Offline Mode</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 512 512"
                                  >
                                    <g>
                                      <path
                                        d="m510.7 475.3-18.6-83.4c-1-4.4-4.4-7.6-8.4-7.6h-13.3c-1.6 0-3.1-.6-4.2-1.8l-44.6-47 5.5 42.3c.5 3.3-2.3 6.6-5.8 6.5h-88.5c-4 0-7.4 3.1-8.4 7.6L306 475.3c-.8 3.4 0 6.9 2 9.4.9 1.2 3 3.2 6.3 3.2h188.1c6 0 9.7-6.9 8.3-12.6zm-97 1.6h-25.6c-3.2 0-5.8-2.6-5.8-5.8v-64.9c0-3.2 2.6-5.8 5.8-5.8h25.6c12.6-.1 21.8 11.1 20.6 23.4 0 5.9-2.4 11.1-6.3 14.9 13.2 12.6 5.3 38.4-14.3 38.2zm-106.7-60c-5.8 1.7-11.6 3-17.5 4.1 17.7-18.1 31.7-52 38.9-94.8 42.8-7.3 76.8-21.3 94.8-38.9-1.6 8.9-3.9 17.7-6.9 26.3-4-2.1-9.2 1.3-8.5 5.9l1.4 10.9c-7.5 15.6-17.5 29.9-29.6 42.5h-46.7c-9.4 0-17.5 6.9-19.7 16.7zm9.4-88.9c-24 126.9-89.2 126.8-113.2 0 34.9 4.9 78.3 4.9 113.2 0zm-125.3-1.8c7.3 42.8 21.3 76.8 39 94.9-67.9-12.3-121.6-66-133.9-133.9 18 17.7 52 31.7 94.9 39zm-1.8-125.3c-2.4 17.7-3.7 36.7-3.7 56.6s1.3 38.9 3.7 56.6C62.4 290 62.5 225 189.3 200.9zm141 113.2c4.9-35 4.9-78.2 0-113.2 58.9 10.9 95.1 33.4 95.7 56.6-.8 23.8-37 45.6-95.7 56.6zm-1.8-125.3c-7.3-42.8-21.2-76.7-38.9-94.8 67.9 12.3 121.5 65.9 133.8 133.8-18.2-17.8-52.1-31.7-94.9-39zm-10.2 10.1c2.6 17.8 4.1 37.4 4.1 58.5s-1.5 40.7-4.1 58.6c-34.9 5.4-82.2 5.3-117.1 0-5.4-34.9-5.4-82.2 0-117.1 34.9-5.3 82.2-5.3 117.1 0zM203.2 187c24.3-126.8 88.8-127.2 113.2 0-34.9-4.9-78.3-4.9-113.2 0zm-4.5-43.5 9.9-44.2c7-2.3 14.1-4 21.4-5.3-17.7 18.1-31.6 52-38.9 94.7-42.9 7.3-76.9 21.3-95 39.1.5-2.6 1-5.2 1.6-7.7 3.6.2 6.9-2.8 6.3-6.6-.5-3.5-.9-7.1-1.3-10.7 5.2-15.1 12.6-29.5 22.2-42.7H179c9.5.1 17.5-6.8 19.7-16.6zm-170.5 5.1h13.3c1.6 0 3.1.6 4.2 1.8l44.5 47c-1.8-13.9-3.7-28.2-5.5-42.3-.5-3.4 2.3-6.6 5.8-6.6H179c3.9 0 7.3-3.1 8.3-7.6 0-.1 18.6-83.4 18.6-83.5.8-3.3 0-6.8-2-9.3-.9-1.2-3-3.3-6.3-3.3H9.6c-7 .6-9.4 6.8-8.4 12.6l18.7 83.5c1 4.5 4.4 7.7 8.3 7.7zM71.1 128l24.1-64.9c1.7-4.9 9.2-5 10.9 0l24.1 64.9c1.1 3-.4 6.4-3.4 7.5s-6.3-.4-7.5-3.4l-10.6-28.7h-16L82 132.1c-2.8 7-13.6 3.1-10.9-4.1zm351.6 325.4c.7 5.9-2.6 11.8-9 11.8h-19.8v-20.8h19.8c5 0 9 4 9 9zm0-32.4c.7 5.9-2.6 11.8-9 11.8h-19.8v-20.9h19.8c5 0 9 4.1 9 9.1zM104.4 91.8H97l3.7-9.9zm200-50.9c-3.2-2.2-3.2-7.3 0-9.5l30.7-21.9c6.2-4.4 12.9 5 6.8 9.5l-14.6 10.5h166.2c3.2 0 5.8 2.6 5.8 5.8v266.1c0 3.2-2.6 5.8-5.8 5.8s-5.8-2.6-5.8-5.8V41h-163l17.2 12.3c6.2 4.5-.6 13.8-6.8 9.5l-30.7-21.9zm-95.5 430.2c3.2 2.2 3.2 7.3 0 9.5l-30.7 21.9c-6.2 4.4-12.9-5-6.8-9.5l14.6-10.5H19.9c-3.2 0-5.8-2.6-5.8-5.8v-266c0-3.2 2.6-5.8 5.8-5.8s5.8 2.6 5.8 5.8V471h162.9l-17.2-12.3c-6.2-4.5.6-13.8 6.8-9.5z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Multi-language Support</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 60 60"
                                  >
                                    <g>
                                      <path
                                        d="M30 20a2 2 0 0 0 2-2v-6a2 2 0 0 0-4 0v6a2 2 0 0 0 2 2ZM15 58h30a2 2 0 0 0 2-2H13a2 2 0 0 0 2 2ZM2 47.05A.99.99 0 0 0 3 48h54a.99.99 0 0 0 1-.95V44H2ZM36.236 50H23.764a7.8 7.8 0 0 1-2.958 4h18.388a7.8 7.8 0 0 1-2.958-4Z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M6 38.03 54 38V6H6ZM26 12a4 4 0 0 1 8 0v6a4 4 0 0 1-8 0Zm-4 4a1 1 0 0 1 2 0v2a6 6 0 0 0 12 0v-2a1 1 0 0 1 2 0v2a8.008 8.008 0 0 1-7 7.931V29a1 1 0 0 1-2 0v-3.069A8.008 8.008 0 0 1 22 18Zm-3.553 17.1 1.356.678 1.49-1.49a1 1 0 0 1 1.414 0L24 33.586l1.293-1.293a1 1 0 0 1 1.414 0L28 33.586l1.293-1.293a1 1 0 0 1 1.414 0L32 33.586l1.293-1.293a1 1 0 0 1 1.414 0L36 33.586l1.293-1.293a1 1 0 0 1 1.414 0l1.49 1.49 1.356-.678A1 1 0 0 1 42 33h3a1 1 0 0 1 0 2h-2.764l-1.789.9a1 1 0 0 1-1.154-.188L38 34.414l-1.293 1.293a1 1 0 0 1-1.414 0L34 34.414l-1.293 1.293a1 1 0 0 1-1.414 0L30 34.414l-1.293 1.293a1 1 0 0 1-1.414 0L26 34.414l-1.293 1.293a1 1 0 0 1-1.414 0L22 34.414l-1.293 1.293a1 1 0 0 1-1.154.188L17.764 35H15a1 1 0 0 1 0-2h3a1 1 0 0 1 .447.1ZM8.293 9.293l1-1a1 1 0 0 1 1.414 1.414l-1 1a1 1 0 0 1-1.414-1.414Zm0 6 7-7a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1-1.414-1.414Z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M57 2H3a.99.99 0 0 0-1 .95V42h56V2.95A.99.99 0 0 0 57 2Zm-1 36.03A1.987 1.987 0 0 1 54 40H6a1.987 1.987 0 0 1-2-1.97V5.97A1.987 1.987 0 0 1 6 4h48a1.987 1.987 0 0 1 2 1.97Z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Voice Recognition and Commands</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 512 512"
                                  >
                                    <g>
                                      <path
                                        d="m0 274.318 143.45 82.485V511.45l-128.09-74.1C5.85 431.853 0 421.69 0 410.687zM231.55 288.808l-73.1 42.032L6.94 243.728v-.01a30.495 30.495 0 0 1 8.42-7.155l123.58-71.492v78.768c0 24.794 20.19 44.97 45 44.97h47.61zM316.9 288.808v122.429c0 11.013-5.85 21.176-15.36 26.662L174.26 511.55l-.81.45V356.803l118.25-67.995zM438.79 103.561c0 7.925-7.47 14.61-16.3 14.61-3.55 0-9.49.03-15.17.05-.02-5.516-.06-23.494-.08-29.281h15.25c8.83.001 16.3 6.696 16.3 14.621z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M497 0H183.94c-8.28 0-15 6.716-15 14.99v228.848c0 8.275 6.72 14.99 15 14.99h177.42v59.96c-.41 12.572 15.89 19.877 25.02 11.153l79.25-71.113H497c8.28 0 15-6.715 15-14.99V14.99C512 6.716 505.28 0 497 0zM322.45 201.896c-7.75 2.928-16.41-.989-19.33-8.734l-6.9-18.268h-48.07l-6.98 18.318c-2.28 5.976-7.98 9.654-14.02 9.654-1.77 0-3.58-.32-5.34-.989-7.74-2.938-11.62-11.602-8.67-19.337l42.8-112.315c.04-.11.09-.23.14-.34a17.522 17.522 0 0 1 16.25-10.923h.02c7.16 0 13.54 4.277 16.26 10.893.06.13.11.27.16.41l42.42 112.315c2.92 7.744-.99 16.398-8.74 19.316zm142.6-23.924c5.47 6.216 4.87 15.68-1.35 21.156-6.198 5.449-15.673 4.885-21.17-1.349l-35.37-40.163v30.26c0 8.275-6.72 14.99-15 14.99-8.29 0-15-6.716-15-14.99V73.951c0-8.275 6.71-14.99 15-14.99h30.33c25.53 0 46.3 20.007 46.3 44.6 0 19.757-13.42 36.556-31.94 42.392zm-205.47-33.058h25.32l-12.6-33.378z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Augmented Reality (AR)</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 64 64"
                                  >
                                    <g>
                                      <path
                                        d="M24.96 2.17c-2.56 0-4.91 1.51-6.01 3.77 2.84 1.11 4.34 4.03 3.68 7.52-.09.48-.51.81-.98.81-.06 0-.12 0-.18-.02a.983.983 0 0 1-.8-1.16c.44-2.35-.4-4.95-3.25-5.52h-.01a.845.845 0 0 1-.17-.05c-.01 0-.03 0-.04-.01-.88-.4-1.8-.6-2.75-.6-3.69 0-6.7 3.01-6.7 6.7 0 .91.19 1.8.55 2.65l.03.09c.52 1.32 1.86 1.96 3.14 1.49.51-.19 1.09.08 1.28.59.19.52-.08 1.1-.6 1.29-.5.18-1.01.27-1.52.27-1.52 0-2.95-.8-3.78-2.15-2.87.8-4.87 3.41-4.87 6.45 0 1.11.27 2.19.79 3.15 2.45-1.08 5.35-.26 6.97 2.09a1.006 1.006 0 0 1-.83 1.57c-.32 0-.63-.15-.82-.43-1.19-1.74-3.42-2.21-5.1-1.08h-.01c-.02.02-.03.03-.05.04A5.952 5.952 0 0 0 0 34.73c0 2.85 2.03 5.31 4.83 5.84a1 1 0 0 1 .76.66c.11.35.03.73-.22 1a6.66 6.66 0 0 0-1.76 4.54c0 3.68 2.98 6.68 6.65 6.7 1.23-.28 4.36-1.38 4.65-2.87.1-.54.62-.89 1.17-.79.54.11.9.64.79 1.18-.48 2.49-3.79 3.75-5.54 4.26a5.926 5.926 0 0 0 8.74 5.07h.01c.07-.1.17-.17.29-.23 1.87-.95 2.63-3.11 1.74-4.92-.25-.5-.05-1.1.45-1.34a.993.993 0 0 1 1.34.45c1.15 2.32.56 4.99-1.29 6.67.93.57 2 .88 3.12.88 2.39 0 4.58-1.47 5.49-3.68V33.99c-1.27-1.16-3.06-1.32-4.48-.36a.997.997 0 1 1-1.12-1.65 5.531 5.531 0 0 1 5.6-.38v-9.56c-1.27-1.16-3.06-1.32-4.49-.37a.999.999 0 0 1-1.11-1.66 5.577 5.577 0 0 1 5.6-.37V6.5a6.67 6.67 0 0 0-6.26-4.33zm-9.97 41.66c-.06 0-.13-.01-.19-.02-3.08-.6-5.03-3.54-4.44-6.7.1-.54.62-.9 1.17-.8.54.1.9.62.79 1.17-.38 2.06.87 3.98 2.86 4.37.54.1.9.63.79 1.17-.09.48-.51.81-.98.81zm-.6-17.67c-.46.31-1.08.19-1.39-.27s-.19-1.08.27-1.39c2.6-1.75 6.06-1.05 7.88 1.6a1.006 1.006 0 0 1-.83 1.57c-.32 0-.63-.16-.82-.44-1.19-1.73-3.43-2.2-5.11-1.07zM25.92 41.6a1 1 0 0 1-.85 1.13c-.28.04-.55.06-.82.06-2.77 0-5.14-2.03-5.58-4.92a.998.998 0 0 1 .84-1.14.996.996 0 0 1 1.14.84c.31 2.07 2.14 3.46 4.14 3.18.54-.09 1.05.3 1.13.85zM38.88 15.62l1.32-2.15c.24.05.49.09.75.09 2.08 0 3.77-1.69 3.77-3.77a3.77 3.77 0 0 0-7.54 0c0 .88.31 1.66.81 2.31l-.95 1.53h-4.13v2.6h4.86c.46 0 .88-.23 1.11-.61z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="m47.28 22.54 3.65-4.27c.2-.24.31-.54.31-.84v-4.12c1.43-.53 2.47-1.9 2.47-3.52 0-2.07-1.7-3.76-3.77-3.76a3.77 3.77 0 0 0-3.77 3.76c0 1.62 1.03 3 2.47 3.52v3.64l-2.95 3.45H32.92V23h13.37c.38 0 .74-.17.99-.46z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="m48.15 28.3 5.15-5.91h3.41c.53 1.43 1.9 2.46 3.52 2.46 2.08 0 3.77-1.69 3.77-3.77a3.77 3.77 0 0 0-3.77-3.76c-1.63 0-3 1.04-3.52 2.47h-4c-.38 0-.74.16-.99.44l-5.15 5.91H32.92v2.6h14.25c.38 0 .74-.16.98-.44zM40.96 50.44c-.26 0-.51.04-.75.09l-1.32-2.15c-.24-.38-.65-.61-1.1-.61h-4.86v2.6h4.13L38 51.9c-.5.64-.81 1.43-.81 2.31a3.77 3.77 0 0 0 7.54 0c0-2.08-1.69-3.77-3.77-3.77z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M51.24 50.69v-4.12c0-.3-.11-.6-.31-.85l-3.65-4.27c-.25-.28-.61-.45-.99-.45H32.92v2.6h12.77l2.95 3.45v3.64c-1.44.53-2.47 1.9-2.47 3.52a3.77 3.77 0 0 0 3.77 3.76c2.07 0 3.77-1.69 3.77-3.76 0-1.62-1.04-3-2.47-3.52z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                      <path
                                        d="M60.23 39.15c-1.62 0-2.99 1.03-3.52 2.46H53.3l-5.15-5.91c-.24-.28-.6-.44-.98-.44H32.92v2.6h13.65l5.15 5.91c.24.28.6.44.99.44h4a3.747 3.747 0 0 0 3.52 2.47A3.77 3.77 0 0 0 64 42.92c0-2.08-1.69-3.77-3.77-3.77z"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>Machine Learning</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 24 24"
                                  >
                                    <g>
                                      <path
                                        d="M1 1a1 1 0 1 0 0 2h1.78a.694.694 35.784 0 1 .657.474l3.297 9.893c.147.44.165.912.053 1.362l-.271 1.087C6.117 17.41 7.358 19 9 19h12a1 1 0 1 0 0-2H9c-.39 0-.64-.32-.545-.697l.205-.818A.64.64 142.028 0 1 9.28 15H20a1 1 0 0 0 .95-.684l2.665-8A1 1 0 0 0 22.666 5H6.555a.694.694 35.783 0 1-.658-.474l-.948-2.842A1 1 0 0 0 4 1zm7 19a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm12 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                        paint-order="fill markers stroke"
                                        fill="#000000"
                                        opacity="1"
                                        data-original="#000000"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>E-commerce Capabilities</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                        </ul>
                        <div className="ctaWrap">
                          <button
                            type="button"
                            class="btn prevStep"
                            onClick={goToPrevStep}
                          >
                            Back
                          </button>
                          <button
                            type="button"
                            class="btn nextStep"
                            onClick={goToNextStep}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="step4" title="4">
                      <div className="pricingContent stepsCommonData stepFourData">
                        <ul>
                          <li>
                            <div className="itemWrap">
                              <h3>Level of expertise required in UI/UX</h3>
                              <div className="rangeSliderWrap">
                                <h4>{valueStepFour}</h4>
                                <input
                                  type="range"
                                  min="0"
                                  max="10"
                                  step="1"
                                  value={valueStepFour}
                                  onChange={handleRangeChangeStepFour}
                                />
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="itemWrap">
                              <h3>
                                Level of Security required in the application
                              </h3>
                              <div className="rangeSliderWrap">
                                <h4>{valueStepFive}</h4>
                                <input
                                  type="range"
                                  min="0"
                                  max="10"
                                  step="1"
                                  value={valueStepFive}
                                  onChange={handleRangeChangeStepFive}
                                />
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="itemWrap">
                              <h3>Urgency</h3>
                              <div className="rangeSliderWrap">
                                <h4>{valueStepSix}</h4>
                                <input
                                  type="range"
                                  min="0"
                                  max="10"
                                  step="1"
                                  value={valueStepSix}
                                  onChange={handleRangeChangeStepSix}
                                />
                              </div>
                            </div>
                          </li>
                        </ul>
                        <div className="ctaWrap">
                          <button
                            type="button"
                            class="btn prevStep"
                            onClick={goToPrevStep}
                          >
                            Back
                          </button>
                          <button
                            type="button"
                            class="btn nextStep"
                            onClick={goToNextStep}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="step5" title="5">
                      <div className="pricingContent stepSevenData">
                        <h3>Number of screens</h3>
                        <p>(Select Atleast One Option)</p>
                        <ul>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 28 28"
                                  >
                                    <g>
                                      <path
                                        fill="#0a0b12"
                                        d="M9 19H5.5A3.504 3.504 0 0 1 2 15.5v-7A3.504 3.504 0 0 1 5.5 5h13A3.504 3.504 0 0 1 22 8.5V10a1 1 0 0 1-2 0V8.5A1.502 1.502 0 0 0 18.5 7h-13A1.502 1.502 0 0 0 4 8.5v7A1.502 1.502 0 0 0 5.5 17H9a1 1 0 0 1 0 2zm17 1.5v-5a2.503 2.503 0 0 0-2.5-2.5h-9a2.503 2.503 0 0 0-2.5 2.5v5a2.503 2.503 0 0 0 2.5 2.5h9a2.503 2.503 0 0 0 2.5-2.5z"
                                        opacity="1"
                                        data-original="#0a0b12"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>1-3 Screens</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 28 28"
                                  >
                                    <g>
                                      <path
                                        fill="#0a0b12"
                                        d="M9 19H5.5A3.504 3.504 0 0 1 2 15.5v-7A3.504 3.504 0 0 1 5.5 5h13A3.504 3.504 0 0 1 22 8.5V10a1 1 0 0 1-2 0V8.5A1.502 1.502 0 0 0 18.5 7h-13A1.502 1.502 0 0 0 4 8.5v7A1.502 1.502 0 0 0 5.5 17H9a1 1 0 0 1 0 2zm17 1.5v-5a2.503 2.503 0 0 0-2.5-2.5h-9a2.503 2.503 0 0 0-2.5 2.5v5a2.503 2.503 0 0 0 2.5 2.5h9a2.503 2.503 0 0 0 2.5-2.5z"
                                        opacity="1"
                                        data-original="#0a0b12"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>3-5 Screens</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 28 28"
                                  >
                                    <g>
                                      <path
                                        fill="#0a0b12"
                                        d="M9 19H5.5A3.504 3.504 0 0 1 2 15.5v-7A3.504 3.504 0 0 1 5.5 5h13A3.504 3.504 0 0 1 22 8.5V10a1 1 0 0 1-2 0V8.5A1.502 1.502 0 0 0 18.5 7h-13A1.502 1.502 0 0 0 4 8.5v7A1.502 1.502 0 0 0 5.5 17H9a1 1 0 0 1 0 2zm17 1.5v-5a2.503 2.503 0 0 0-2.5-2.5h-9a2.503 2.503 0 0 0-2.5 2.5v5a2.503 2.503 0 0 0 2.5 2.5h9a2.503 2.503 0 0 0 2.5-2.5z"
                                        opacity="1"
                                        data-original="#0a0b12"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>5-10 Screens</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 28 28"
                                  >
                                    <g>
                                      <path
                                        fill="#0a0b12"
                                        d="M9 19H5.5A3.504 3.504 0 0 1 2 15.5v-7A3.504 3.504 0 0 1 5.5 5h13A3.504 3.504 0 0 1 22 8.5V10a1 1 0 0 1-2 0V8.5A1.502 1.502 0 0 0 18.5 7h-13A1.502 1.502 0 0 0 4 8.5v7A1.502 1.502 0 0 0 5.5 17H9a1 1 0 0 1 0 2zm17 1.5v-5a2.503 2.503 0 0 0-2.5-2.5h-9a2.503 2.503 0 0 0-2.5 2.5v5a2.503 2.503 0 0 0 2.5 2.5h9a2.503 2.503 0 0 0 2.5-2.5z"
                                        opacity="1"
                                        data-original="#0a0b12"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>10-20 Screens</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                          <li>
                            <label class="controlCheckbox">
                              <input type="checkbox" />
                              <div class="controlIndicator">
                                <div className="icoWrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="22"
                                    height="22"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 28 28"
                                  >
                                    <g>
                                      <path
                                        fill="#0a0b12"
                                        d="M9 19H5.5A3.504 3.504 0 0 1 2 15.5v-7A3.504 3.504 0 0 1 5.5 5h13A3.504 3.504 0 0 1 22 8.5V10a1 1 0 0 1-2 0V8.5A1.502 1.502 0 0 0 18.5 7h-13A1.502 1.502 0 0 0 4 8.5v7A1.502 1.502 0 0 0 5.5 17H9a1 1 0 0 1 0 2zm17 1.5v-5a2.503 2.503 0 0 0-2.5-2.5h-9a2.503 2.503 0 0 0-2.5 2.5v5a2.503 2.503 0 0 0 2.5 2.5h9a2.503 2.503 0 0 0 2.5-2.5z"
                                        opacity="1"
                                        data-original="#0a0b12"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <div className="dataWrap">
                                  <h2>20+ Screens</h2>
                                </div>
                              </div>
                            </label>
                          </li>
                        </ul>
                        <div className="ctaWrap">
                          <button
                            type="button"
                            class="btn nextStep"
                            onClick={() => setLgShow(true)}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        className="contactUsPopup"
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="titleWrap">
            <h2>Let's get in touch</h2>
            <p>
              Kindly fill out the form below, and our team will promptly respond
              to your inquiries.
            </p>
          </div>
          <form onSubmit={handleSubmit}>
            <ul className="formList">
              <li>
                <div className="inputField">
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
              </li>
              <li>
                <div className="inputField">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </li>
              <li>
                <div className="inputField">
                  <label>Mobile Number</label>
                  <input
                    type="tel"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    required
                  />
                </div>
              </li>
              <li>
                <div className="inputField selectField">
                  <label>I'm interested in:</label>
                  <select
                    name="interest"
                    value={formData.interest}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select an option</option>
                    <option>Artificial Intelligence</option>
                    <option>Machine Learning</option>
                    <option>Custom GPT</option>
                    <option>Blockchain/Etherium</option>
                    <option>E-Commerce/Shopping Cart</option>
                    <option>Salesforce CRM</option>
                    <option>Zoho CRM</option>
                    <option>Custom CRM</option>
                    <option>Website Development</option>
                    <option>SEO</option>
                    <option>Social Media Management</option>
                    <option>Mobile Application Development</option>
                    <option>Custom Application Development</option>
                    <option>Security and Testing</option>
                    <option>Other</option>
                  </select>
                </div>
              </li>
              <li className="full">
                <div className="inputField">
                  <label>Message</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
              </li>
              <li className="full">
                <div className="inputField">
                  <ReCAPTCHA
                    sitekey="6LfVNpMrAAAAAIfAv93ShHt8EO2h8gDh8WZRy4vW"
                    onChange={handleCaptchaChange}
                    ref={recaptchaRef}
                  />
                </div>
              </li>
              <li className="full">
                <div className="ctaWrap">
                  <button type="submit" className="btnSubmti">
                    Submit
                  </button>
                </div>
              </li>
            </ul>
          </form>
        </Modal.Body>
      </Modal>
      <Modal
        size="md"
        show={showThankYou}
        onHide={() => setShowThankYou(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        className="contactUsPopup"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="thankYouPopup">
            <h3>Thank you for contacting us!</h3>
            <p>We will respond to your inquiry shortly.</p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default Pricing;
